function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function (obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};
var __spreadValues = function (a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __publicField = function (obj, key, value) {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { Controller } from "stimulus";
import { camelCase, debounce, upperFirst, clamp, get, set } from "lodash-es";
import { isPast, intervalToDuration, formatDuration, toDate, formatDistanceToNow } from "date-fns";
class BaseController extends Controller {
  constructor(context) {
    var _this;
    super(context);
    _this = this;
    if (!this.application.debug) {
      return this;
    }
    return new Proxy(this, {
      get: function (obj, prop) {
        let returnVal = Reflect.get(obj, prop);
        let self = _this;
        if (logProperty(prop.toString())) {
          if (typeof returnVal == "function") {
            return new Proxy(returnVal, {
              apply(target, thisArg, argArray) {
                self.log(prop.toString(), {
                  args: argArray
                });
                return Reflect.apply(target, thisArg, argArray);
              }
            });
          } else {
            _this.log(prop.toString());
          }
        }
        return returnVal;
      }
    });
  }
  get el() {
    return this.element;
  }
  get isTurboPreview() {
    return document.documentElement.hasAttribute("data-turbo-preview") || document.documentElement.hasAttribute("data-turbolinks-preview");
  }
  get isTurbolinksPreview() {
    return this.isTurboPreview;
  }
  get csrfToken() {
    return this.metaValue("csrf-token");
  }
  metaValue(name) {
    const element = document.head.querySelector("meta[name=\"".concat(name, "\"]"));
    return (element == null ? void 0 : element.getAttribute("content")) || null;
  }
  dispatch(element, eventName) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    let mergedOptions = Object.assign({}, {
      bubbles: true,
      cancelable: true,
      detail: {
        target: element,
        element
      }
    }, options);
    if (!!mergedOptions.detail.target) {
      mergedOptions.detail.target = element;
    }
    let event = new CustomEvent(eventName, mergedOptions);
    this.logEvent(eventName, event, element);
    element.dispatchEvent(event);
  }
  log(functionName) {
    let args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!this.application.debug) {
      return;
    }
    let logger = console;
    logger.groupCollapsed("%c".concat(this.identifier, " %c#").concat(functionName), "color: #3B82F6", "color: unset");
    logger.log(__spreadValues({
      element: this.element,
      controller: this
    }, args));
    logger.groupEnd();
  }
  warn(warning) {
    let args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!this.application.debug) {
      return;
    }
    let logger = console;
    logger.groupCollapsed("%c".concat(this.identifier, " %c#").concat(warning), "color: F39B1AFF", "color: unset");
    logger.warn(__spreadValues({
      element: this.element,
      controller: this
    }, args));
    logger.groupEnd();
  }
  logEvent(eventName, event, element) {
    if (!this.application.debug) {
      return;
    }
    let logger = console;
    logger.groupCollapsed("%c".concat(this.identifier, " %c").concat(eventName, "%c"), "color: #3B82F6", "color: #0be000", "color: unset");
    logger.log({
      element
    });
    logger.groupEnd();
  }
}
function logProperty(prop) {
  switch (prop) {
    case "application":
    case "el":
    case "element":
    case "constructor":
    case "initialize":
    case "log":
    case "logEvent":
    case "dispatch":
    case "data":
    case "valueDescriptorMap":
    case "mutate":
    case "identifier":
      return false;
  }
  if (/^_.*?$/.test(prop)) {
    return false;
  }
  if (/^.*?Target(s)?$/.test(prop)) {
    return false;
  }
  if (/^.*?Value$/.test(prop)) {
    return false;
  }
  if (/^.*?ValueChanged$/.test(prop)) {
    return false;
  }
  if (/^.*?Class$/.test(prop)) {
    return false;
  }
  if (/^.*?Classes$/.test(prop)) {
    return false;
  }
  if (/^.*?ClassesPresent$/.test(prop)) {
    return false;
  }
  return true;
}
class EphemeralController extends BaseController {
  _cleanupSelf() {
    this.cleanup(this.el);
  }
  cleanup(element) {
    var _this2 = this;
    var _a, _b, _c;
    element.dataset.controller = ((_a = element.dataset.controller) == null ? void 0 : _a.replaceAll(new RegExp("(\\s|^)".concat(this.identifier, "(\\s|$)"), "g"), "")) || "";
    if (element.dataset.controller == "") {
      delete element.dataset.controller;
    }
    let substringIdentifierValueRegex = new RegExp("(\\s|^)".concat(this.identifier, "\\..+?(\\s|$)"), "g");
    element.dataset.target = ((_b = element.dataset.target) == null ? void 0 : _b.replaceAll(substringIdentifierValueRegex, "")) || "";
    delete element.dataset[camelCase("".concat(this.identifier, "-target"))];
    if (element.dataset.target == "") {
      delete element.dataset.target;
    }
    element.dataset.action = ((_c = element.dataset.target) == null ? void 0 : _c.replaceAll(substringIdentifierValueRegex, "")) || "";
    delete element.dataset[camelCase("".concat(this.identifier, "-action"))];
    if (element.dataset.action == "") {
      delete element.dataset.action;
    }
    let values = this.constructor.values;
    if (values) {
      Object.keys(values).forEach(function (val) {
        return delete element.dataset[camelCase("".concat(_this2.identifier, "-").concat(val, "-value"))];
      });
    }
    let classes = this.constructor.classes;
    if (classes) {
      Object.keys(classes).forEach(function (val) {
        return delete element.dataset[camelCase("".concat(_this2.identifier, "-").concat(val, "-class"))];
      });
    }
  }
}
const smoothSupported = ("scrollBehavior" in document.documentElement.style);
let smoothPolyfilled;
async function scrollToElement(element) {
  let _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$behavior = _ref.behavior,
    behavior = _ref$behavior === void 0 ? "smooth" : _ref$behavior,
    _ref$block = _ref.block,
    block = _ref$block === void 0 ? "start" : _ref$block,
    _ref$inline = _ref.inline,
    inline = _ref$inline === void 0 ? "nearest" : _ref$inline;
  if (behavior == "smooth" && !smoothSupported) {
    await polyfillSmooth();
  }
  element.scrollIntoView({
    behavior,
    block,
    inline
  });
}
async function scrollAbsoluteTop(element) {
  let _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref2$behavior = _ref2.behavior,
    behavior = _ref2$behavior === void 0 ? "smooth" : _ref2$behavior;
  if (behavior == "smooth" && !smoothSupported) {
    await polyfillSmooth();
  }
  element.scrollTo({
    top: 0,
    left: 0,
    behavior
  });
}
async function scrollAbsoluteBottom(element) {
  let _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref3$behavior = _ref3.behavior,
    behavior = _ref3$behavior === void 0 ? "smooth" : _ref3$behavior;
  if (behavior == "smooth" && !smoothSupported) {
    await polyfillSmooth();
  }
  if (element == window) {
    element.scrollTo({
      top: document.body.scrollHeight,
      left: 0,
      behavior
    });
  } else {
    element.scrollTo({
      top: element.scrollHeight,
      left: 0,
      behavior
    });
  }
}
async function scrollAbsoluteLeft(element) {
  let _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref4$behavior = _ref4.behavior,
    behavior = _ref4$behavior === void 0 ? "smooth" : _ref4$behavior;
  if (behavior == "smooth" && !smoothSupported) {
    await polyfillSmooth();
  }
  element.scrollTo({
    left: 0,
    behavior
  });
}
async function scrollAbsoluteRight(element) {
  let _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref5$behavior = _ref5.behavior,
    behavior = _ref5$behavior === void 0 ? "smooth" : _ref5$behavior;
  if (behavior == "smooth" && !smoothSupported) {
    await polyfillSmooth();
  }
  if (element == window) {
    element.scrollTo({
      left: document.body.scrollWidth,
      behavior
    });
  } else {
    element.scrollTo({
      left: element.scrollWidth,
      behavior
    });
  }
}
async function scrollUp(element, amount) {
  let _ref6 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref6$behavior = _ref6.behavior,
    behavior = _ref6$behavior === void 0 ? "smooth" : _ref6$behavior;
  if (behavior == "smooth" && !smoothSupported) {
    await polyfillSmooth();
  }
  element.scrollBy({
    top: -amount,
    left: 0,
    behavior
  });
}
async function scrollDown(element, amount) {
  let _ref7 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref7$behavior = _ref7.behavior,
    behavior = _ref7$behavior === void 0 ? "smooth" : _ref7$behavior;
  if (behavior == "smooth" && !smoothSupported) {
    await polyfillSmooth();
  }
  element.scrollBy({
    top: amount,
    left: 0,
    behavior
  });
}
async function scrollLeft(element, amount) {
  let _ref8 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref8$behavior = _ref8.behavior,
    behavior = _ref8$behavior === void 0 ? "smooth" : _ref8$behavior;
  if (behavior == "smooth" && !smoothSupported) {
    await polyfillSmooth();
  }
  element.scrollBy({
    top: 0,
    left: -amount,
    behavior
  });
}
async function scrollRight(element, amount) {
  let _ref9 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref9$behavior = _ref9.behavior,
    behavior = _ref9$behavior === void 0 ? "smooth" : _ref9$behavior;
  if (behavior == "smooth" && !smoothSupported) {
    await polyfillSmooth();
  }
  element.scrollBy({
    top: 0,
    left: amount,
    behavior
  });
}
async function polyfillSmooth() {
  const _await$import = await import( /* webpackChunkName: "smoothscroll-polyfill" */
    "smoothscroll-polyfill"),
    polyfill = _await$import.polyfill;
  if (smoothPolyfilled) {
    return;
  }
  smoothPolyfilled = true;
  polyfill();
}
function getScrollParent(node) {
  if (!node) {
    return null;
  }
  if (node == document.body) {
    return window;
  }
  const overflowY = getComputedStyle(node).overflowY;
  const isScrollable = overflowY !== "visible" && overflowY !== "hidden";
  if (isScrollable && node.scrollHeight >= node.clientHeight) {
    return node;
  }
  return getScrollParent(node.parentElement) || document.body;
}
function isTurboFrame(element) {
  return element.nodeName == "TURBO-FRAME";
}
function mitt(n) {
  return {
    all: n = n || new Map(),
    on: function (t, e) {
      var i = n.get(t);
      i ? i.push(e) : n.set(t, [e]);
    },
    off: function (t, e) {
      var i = n.get(t);
      i && (e ? i.splice(i.indexOf(e) >>> 0, 1) : n.set(t, []));
    },
    emit: function (t, e) {
      var i = n.get(t);
      i && i.slice().map(function (n2) {
        n2(e);
      }), (i = n.get("*")) && i.slice().map(function (n2) {
        n2(t, e);
      });
    }
  };
}
const EventBus = mitt();
function isHTMLLinkElement(element) {
  return element.nodeName == "LINK";
}
function isHTMLAnchorElement(element) {
  return element.nodeName == "A";
}
function isHTMLFormElement(element) {
  return element.nodeName == "FORM";
}
function isHTMLInputElement(element) {
  return element.nodeName == "INPUT";
}
function isHTMLTextAreaElement(element) {
  return element.nodeName == "TEXTAREA";
}
function isHTMLButtonElement(element) {
  return element.nodeName == "BUTTON";
}
function isHTMLSelectElement(element) {
  return element.nodeName == "SELECT";
}
function isHTMLImageElement(element) {
  return element.nodeName == "IMG";
}
function isElementCheckable(element) {
  return isHTMLInputElement(element) && (element.type === "radio" || element.type === "checkbox");
}
function isTypeOfFormInputElement(element) {
  return isHTMLInputElement(element) || isHTMLSelectElement(element) || isHTMLTextAreaElement(element);
}
function createHiddenButton(type) {
  let button = document.createElement("button");
  button.type = type;
  button.style.display = "none";
  button.dataset.sythentic = "true";
  return button;
}
function createHiddenInput(name, value) {
  let input = document.createElement("input");
  input.type = "hidden";
  input.name = name;
  input.value = value;
  return input;
}
function insertElement(targetElement, insertPosition, element) {
  let createdElement = targetElement.insertAdjacentElement(insertPosition, element);
  if (!createdElement) {
    throw new Error("Failed to insert element ".concat(element.nodeName, " into ").concat(targetElement.nodeName));
  }
  return createdElement;
}
function insertHiddenInput(name, value, targetElement, insertPosition) {
  return insertElement(targetElement, insertPosition, createHiddenInput(name, value));
}
function insertHiddenButton(type, targetElement, insertPosition) {
  return insertElement(targetElement, insertPosition, createHiddenButton(type));
}
function getAllRadiosInGroup(radio) {
  let parent = radio.form || document;
  return Array.from(parent.querySelectorAll("input[type=\"radio\"][name=\"".concat(radio.name, "\"]")));
}
function getOtherRadiosInGroup(radio) {
  return getAllRadiosInGroup(radio).filter(function (r) {
    return r !== radio;
  });
}
function isElementInViewport(el) {
  const rect = el.getBoundingClientRect();
  const windowHeight = window.innerHeight || document.documentElement.clientHeight;
  const windowWidth = window.innerWidth || document.documentElement.clientWidth;
  const vertInView = rect.top <= windowHeight && rect.top + rect.height >= 0;
  const horInView = rect.left <= windowWidth && rect.left + rect.width >= 0;
  return vertInView && horInView;
}
function requestSubmit(form) {
  if (form.requestSubmit) {
    form.requestSubmit();
  } else {
    let button = form.querySelector('button[type="submit"]');
    if (!button) {
      button = insertHiddenButton("submit", form, "beforeend");
    }
    button.click();
  }
}
function requestReset(form) {
  let button = form.querySelector('button[type="reset"]');
  if (!button) {
    button = insertHiddenButton("reset", form, "beforeend");
  }
  button.click();
}
function wrapArray(x) {
  return Array.isArray(x) ? x : [x];
}
function useMixin(controller, setup, teardown) {
  const controllerDisconnect = controller.disconnect.bind(controller);
  setup();
  Object.assign(controller, {
    disconnect() {
      teardown();
      controllerDisconnect();
    }
  });
  return controllerDisconnect;
}
function useEventListener(controller, element, eventNameOrNames, handler, opts) {
  if (opts == null ? void 0 : opts.debounce) {
    handler = debounce(handler.bind(controller), opts.debounce);
    delete opts.debounce;
  } else {
    handler = handler.bind(controller);
  }
  let eventNames = wrapArray(eventNameOrNames);
  let setup = function () {
    return eventNames.forEach(function (eventName) {
      return element.addEventListener(eventName, handler, opts);
    });
  };
  let teardown = function () {
    return eventNames.forEach(function (eventName) {
      return element.removeEventListener(eventName, handler);
    });
  };
  useMixin(controller, setup, teardown);
  return {
    setup,
    teardown
  };
}
function useEventListeners(controller, element, eventNameOrNames, handler, opts) {
  return useEventListener(controller, element, eventNameOrNames, handler, opts);
}
function useCollectionEventListener(controller, elements, eventNameOrNames, handler, opts) {
  let handlers = [];
  elements.forEach(function (el) {
    let _useEventListener = useEventListener(controller, el, eventNameOrNames, handler, opts),
      setup = _useEventListener.setup,
      teardown = _useEventListener.teardown;
    handlers.push({
      setup,
      teardown
    });
  });
  return [function () {
    return handlers.forEach(function (h) {
      return h.setup();
    });
  }, function () {
    return handlers.forEach(function (h) {
      return h.teardown();
    });
  }];
}
function useCollectionEventListeners(controller, elements, eventNameOrNames, handler, opts) {
  return useCollectionEventListener(controller, elements, eventNameOrNames, handler, opts);
}
function useFullscreen(controller, el) {
  let element = el || document.documentElement;
  let fullscreenOpen = document.fullscreenElement !== null;
  const updateFullscreenState = function () {
    return fullscreenOpen = document.fullscreenElement !== null;
  };
  const isFullscreen = function () {
    return fullscreenOpen;
  };
  const toggle = async function () {
    return fullscreenOpen ? await exit() : await enter();
  };
  let setup = function () {
    return document.addEventListener("fullscreenchange", updateFullscreenState);
  };
  let teardown = function () {
    return document.removeEventListener("fullscreenchange", updateFullscreenState);
  };
  const exit = async function () {
    if (document.exitFullscreen) {
      fullscreenOpen = false;
      await document.exitFullscreen();
    }
  };
  const enter = async function () {
    if (fullscreenOpen) {
      await exit();
    }
    if (element.requestFullscreen) {
      await element.requestFullscreen();
      fullscreenOpen = true;
    }
  };
  useMixin(controller, setup, teardown);
  return {
    isFullscreen,
    enter,
    exit,
    toggle,
    teardown
  };
}
function reactive(object) {
  if (object === null || typeof object !== "object") {
    return object;
  }
  for (const property in object) {
    if (Object.getOwnPropertyDescriptor(object, property) == void 0) {
      continue;
    }
    object[property] = reactive(object[property]);
  }
  return new Proxy(object, {
    get(target, property) {
      return target[property];
    },
    set(target, property, value) {
      target[property] = reactive(value);
      return true;
    }
  });
}
function useGeolocation(controller) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let update = arguments.length > 2 ? arguments[2] : undefined;
  let error = arguments.length > 3 ? arguments[3] : undefined;
  if (update) {
    update = update.bind(controller);
  }
  if (error) {
    error = error.bind(controller);
  }
  const _options$enableHighAc = options.enableHighAccuracy,
    enableHighAccuracy = _options$enableHighAc === void 0 ? true : _options$enableHighAc,
    _options$maximumAge = options.maximumAge,
    maximumAge = _options$maximumAge === void 0 ? 3e4 : _options$maximumAge,
    _options$timeout = options.timeout,
    timeout = _options$timeout === void 0 ? 27e3 : _options$timeout;
  const isSupported = navigator && "geolocation" in navigator;
  const values = reactive({
    locatedAt: null,
    error: null,
    coords: {
      accuracy: 0,
      latitude: Infinity,
      longitude: Infinity,
      altitude: null,
      altitudeAccuracy: null,
      heading: null,
      speed: null
    },
    teardown: function () {
      if (watcher) {
        navigator.geolocation.clearWatch(watcher);
        watcher = null;
      }
    }
  });
  let setup = function () {
    if (isSupported) {
      watcher = navigator.geolocation.watchPosition(function (position) {
        values.locatedAt = position.timestamp;
        values.coords = position.coords;
        values.error = null;
        if (update) {
          update(position);
        }
      }, function (err) {
        values.error = err;
        if (error) {
          error(err);
        }
      }, {
        enableHighAccuracy,
        maximumAge,
        timeout
      });
    }
  };
  let watcher = null;
  useMixin(controller, setup, values.teardown);
  return values;
}
function useInjectedFragment(controller, targetElement, insertPosition, fragment) {
  let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  let nodes = Array.from(fragment.childNodes);
  let setup = function () {
    let parent = targetElement.parentElement;
    if (["beforebegin", "afterend"].includes(insertPosition) && parent == null) {
      throw new Error("Cannot insert beforebegin into a node with no parent");
    }
    switch (insertPosition) {
      case "beforeend":
        targetElement.append(fragment);
        break;
      case "afterbegin":
        targetElement.prepend(fragment);
        break;
      case "beforebegin":
        parent.insertBefore(fragment, targetElement);
        break;
      case "afterend":
        parent.insertBefore(fragment, targetElement);
        break;
    }
  };
  let teardown = options.cleanup ? function () {
    return nodes.forEach(function (node) {
      return node.remove();
    });
  } : function () {
    return void 0;
  };
  useMixin(controller, setup, teardown);
  return [nodes, teardown];
}
function useInjectedHTML(controller, targetElement, insertPosition, html) {
  let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  const fragment = document.createRange().createContextualFragment(html);
  return useInjectedFragment(controller, targetElement, insertPosition, fragment, options);
}
function useInjectedElement(controller, targetElement, insertPosition, element) {
  let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  const fragment = new DocumentFragment();
  fragment.append(element);
  let _useInjectedFragment = useInjectedFragment(controller, targetElement, insertPosition, fragment, options),
    _useInjectedFragment2 = _slicedToArray(_useInjectedFragment, 2),
    nodes = _useInjectedFragment2[0],
    teardown = _useInjectedFragment2[1];
  return [nodes[0], teardown];
}
const StorageSerializers = {
  boolean: {
    read: function (v) {
      return v === "true";
    },
    write: function (v) {
      return String(v);
    }
  },
  object: {
    read: function (v) {
      return JSON.parse(v);
    },
    write: function (v) {
      return JSON.stringify(v);
    }
  },
  number: {
    read: function (v) {
      return Number.parseFloat(v);
    },
    write: function (v) {
      return String(v);
    }
  },
  any: {
    read: function (v) {
      return v;
    },
    write: function (v) {
      return String(v);
    }
  },
  string: {
    read: function (v) {
      return v;
    },
    write: function (v) {
      return String(v);
    }
  },
  map: {
    read: function (v) {
      return new Map(JSON.parse(v));
    },
    write: function (v) {
      return JSON.stringify(Array.from(v.entries()));
    }
  },
  set: {
    read: function (v) {
      return new Set(JSON.parse(v));
    },
    write: function (v) {
      return JSON.stringify(Array.from(v.entries()));
    }
  }
};
function useLocalStorage(controller, key, defaultValue, opts) {
  let type = "any";
  let writeDefaults = opts.writeDefaults;
  if (defaultValue == null) {
    type = "any";
  }
  if (defaultValue instanceof Set) {
    type = "set";
  }
  if (defaultValue instanceof Map) {
    type = "map";
  }
  if (typeof defaultValue === "boolean") {
    type = "boolean";
  }
  if (typeof defaultValue === "string") {
    type = "string";
  }
  if (typeof defaultValue === "object") {
    type = "object";
  }
  if (Array.isArray(defaultValue)) {
    type = "object";
  }
  if (!Number.isNaN(defaultValue)) {
    type = "number";
  }
  let data = reactive({
    value: defaultValue
  });
  let storage = localStorage;
  const serializer = StorageSerializers[type];
  const read = function (event) {
    if (event && event.key !== key) {
      return;
    }
    try {
      const rawValue = event ? event.newValue : storage.getItem(key);
      if (rawValue == null) {
        data.value = defaultValue;
        if (writeDefaults && defaultValue !== null) {
          storage.setItem(key, serializer.write(defaultValue));
        }
      } else {
        data.value = serializer.read(rawValue);
      }
    } catch (e) {}
  };
  read();
  return {
    get value() {
      return data.value;
    },
    set value(value) {
      data.value = value;
      storage.setItem(key, serializer.write(value));
    },
    read
  };
}
function useInterval(controller, handler, interval) {
  handler = handler.bind(controller);
  let intervalHandle = null;
  let setup = function () {
    return intervalHandle = setInterval(handler, interval);
  };
  let teardown = function () {
    if (intervalHandle !== null) {
      clearInterval(intervalHandle);
    }
  };
  useMixin(controller, setup, teardown);
  return teardown;
}
function useTimeout(controller, handler, timeout) {
  let controllerDisconnect;
  let timeoutHandle = null;
  handler = handler.bind(controller);
  let newHandler = function () {
    handler();
    timeoutHandle = null;
    Object.assign(controller, {
      disconnect: controllerDisconnect
    });
  };
  let setup = function () {
    return timeoutHandle = setTimeout(newHandler, timeout);
  };
  let teardown = function () {
    if (timeoutHandle !== null) {
      clearTimeout(timeoutHandle);
      timeoutHandle = null;
    }
  };
  controllerDisconnect = useMixin(controller, setup, teardown);
  return teardown;
}
async function fetchRetry(n, input, init) {
  try {
    return await fetch(input, init);
  } catch (err) {
    if (n === 1) {
      throw err;
    }
    return await fetchRetry(n - 1, input, init);
  }
}
class LoadBlockController extends BaseController {
  get _errorMessage() {
    return this.hasErrorMessageValue ? this.errorMessageValue : "This content failed to load";
  }
  get _maxRetries() {
    return this.hasMaxRetriesValue ? this.maxRetriesValue : 1;
  }
  connect() {}
  async loadContent() {
    var _this3 = this;
    let event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    event == null ? void 0 : event.preventDefault();
    let self = this;
    let el = this.hasReplaceTarget ? this.replaceTarget : this.el;
    let failure = function () {
      el.replaceWith(_this3._errorMessage);
      self.dispatch(el, "ajax:error");
    };
    try {
      let response = await fetchRetry(this._maxRetries, this.endpointValue);
      if (!response.ok) {
        failure();
      }
      let text = await response.text();
      let newEl = document.createElement("div");
      newEl.innerHTML = text;
      if (this.hasSelectorValue) {
        let selectedContent = newEl.querySelectorAll(this.selectorValue);
        el.replaceWith(...selectedContent);
      } else {
        el.replaceWith(...newEl.children);
      }
      self.dispatch(el, "ajax:success");
    } catch (e) {
      failure();
    } finally {
      self.dispatch(el, "ajax:complete");
    }
  }
}
__publicField(LoadBlockController, "targets", ["replace"]);
__publicField(LoadBlockController, "values", {
  endpoint: String,
  errorMessage: String,
  selector: String,
  maxRetries: Number
});
class AsyncBlockController extends LoadBlockController {
  get _errorMessage() {
    return this.hasErrorMessageValue ? this.errorMessageValue : "This content failed to load";
  }
  async connect() {
    await this.loadContent();
  }
}
__publicField(AsyncBlockController, "targets", ["replace"]);
__publicField(AsyncBlockController, "values", {
  endpoint: String,
  errorMessage: String,
  selector: String,
  maxRetries: Number
});
function useIntersectionObserver(controller, handler, options) {
  handler = handler.bind(controller);
  let observer = new IntersectionObserver(handler, options);
  let teardown = function () {
    observer == null ? void 0 : observer.disconnect();
    observer = null;
  };
  let observe = function (element) {
    return observer == null ? void 0 : observer.observe(element);
  };
  let unobserve = function (element) {
    return observer == null ? void 0 : observer.unobserve(element);
  };
  return {
    observer,
    teardown,
    observe,
    unobserve
  };
}
function useIntersection(controller, element, appear, disappear, options) {
  if (appear) {
    appear = appear.bind(controller);
  }
  if (disappear) {
    disappear = disappear.bind(controller);
  }
  let opts = options != null ? options : {};
  let processEntries = function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        appear && appear(entry);
      } else {
        disappear && disappear(entry);
      }
    });
  };
  let _useIntersectionObser = useIntersectionObserver(controller, processEntries, opts),
    observer = _useIntersectionObser.observer,
    observe = _useIntersectionObser.observe,
    unobserve = _useIntersectionObser.unobserve,
    teardown = _useIntersectionObser.teardown;
  let setup = function () {
    return observe(element);
  };
  useMixin(controller, setup, teardown);
  return {
    observer,
    observe: function () {
      return observe(element);
    },
    unobserve: function () {
      return unobserve(element);
    },
    teardown
  };
}
class LazyBlockController extends LoadBlockController {
  async connect() {
    let element = this.el;
    if ("IntersectionObserver" in window) {
      let _useIntersection = useIntersection(this, element, this.appear, null, {
          threshold: 0.3
        }),
        observe = _useIntersection.observe,
        unobserve = _useIntersection.unobserve;
      this.observe = observe;
      this.unobserve = unobserve;
    } else {
      await this.loadContent();
    }
  }
  async appear(entry) {
    if (entry.target === this.el && entry.isIntersecting) {
      await this.loadContent();
      if (this.unobserve) {
        this.unobserve();
      }
    }
  }
}
class PollBlockController extends LoadBlockController {
  connect() {
    var _this4 = this;
    if (!this.hasSecondsValue) {
      throw new Error("Required value `seconds` is missing");
    }
    requestAnimationFrame(function () {
      _this4._timeout();
      useInterval(_this4, _this4._timeout, _this4.secondsValue * 1e3);
    });
  }
  async _timeout() {
    await this.loadContent();
  }
}
__publicField(PollBlockController, "targets", ["replace"]);
__publicField(PollBlockController, "values", {
  endpoint: String,
  errorMessage: String,
  selector: String,
  maxRetries: Number,
  seconds: Number
});
class AutoSubmitFormController extends BaseController {
  get _eventMode() {
    if (this.hasEventModeValue) {
      if (!["change", "input", "debounced"].includes(this.eventModeValue)) {
        throw new Error("The modeValue provided '".concat(this.eventModeValue, "' is not one of the recognised configuration options"));
      }
      return this.eventModeValue;
    } else {
      return "change";
    }
  }
  get _debounceTimeout() {
    return this.hasDebounceIntervalValue ? this.debounceIntervalValue : 1e3;
  }
  get _mode() {
    if (this.hasSubmitModeValue) {
      if (!["direct", "request"].includes(this.submitModeValue)) {
        throw new Error("The modeValue provided '".concat(this.submitModeValue, "' is not one of the recognised configuration options"));
      }
      return this.submitModeValue;
    } else {
      return "request";
    }
  }
  get _cssSelector() {
    let inputTypes = ["input", "textarea", "select"];
    let ignore = ":not([data-no-autosubmit])";
    return inputTypes.map(function (type) {
      return type.concat(ignore);
    }).join(",");
  }
  get inputElements() {
    return this.element.querySelectorAll(this._cssSelector);
  }
  connect() {
    var _this5 = this;
    this.inputElements.forEach(function (el) {
      return useEventListener(_this5, el, _this5._eventMode == "change" ? "change" : "input", _this5.submit, {
        debounce: _this5._eventMode == "debounced" ? _this5._debounceTimeout : void 0
      });
    });
  }
  submit() {
    let el = this.el;
    if (this._mode == "request") {
      requestSubmit(el);
    } else {
      el.submit();
    }
  }
}
__publicField(AutoSubmitFormController, "values", {
  submitMode: String,
  eventMode: String,
  debounceInterval: Number
});
class AutosizeController extends BaseController {
  connect() {
    var _this6 = this;
    let _useIntersection2 = useIntersection(this, this.el, this.appear),
      teardown = _useIntersection2.teardown;
    this._unobserveIntersection = teardown;
    if (!isHTMLTextAreaElement(this.el)) {
      throw new Error("Expected controller to be attached to a textarea, but was a '".concat(this.el.tagName, "'"));
    }
    requestAnimationFrame(function () {
      _this6.el.style.resize = "none";
      _this6.el.style.boxSizing = "border-box";
      _this6._handler();
      useEventListener(_this6, window, ["resize"], _this6._handler);
      useEventListener(_this6, _this6.el, ["input", "change", "focus"], _this6._handler, {
        debounce: 100
      });
    });
  }
  appear(_entry) {
    this.autosize(this.el);
    this._unobserveIntersection();
  }
  _handler() {
    this.autosize(this.el);
  }
  autosize(element) {
    let offset = element.offsetHeight - element.clientHeight;
    element.style.height = "auto";
    element.style.height = element.scrollHeight + offset + "px";
  }
}
function controllerMethod(controller, methodName) {
  const method = controller[methodName];
  if (typeof method == "function") {
    return method;
  } else if (method != void 0) {
    return function () {
      return method;
    };
  } else {
    return function () {
      return void 0;
    };
  }
}
function pascalCase(str) {
  return upperFirst(camelCase(str));
}
function addMethodsForClassDefinition(controller, name) {
  let defaultElement = controller.element;
  let hasClass = function () {
    return controller["has".concat(pascalCase(name), "Class")] == true;
  };
  let classes = function () {
    return controller["".concat(name, "Classes")];
  };
  let defaultClasses = function () {
    return controllerMethod(controller, "default".concat(pascalCase(name), "Classes")).call(controller) || [];
  };
  let classOrDefault = function () {
    return hasClass() ? classes() : defaultClasses();
  };
  if (controller["".concat(name, "Classes")] == void 0) {
    Object.defineProperty(controller, "".concat(name, "Classes"), {
      get: function () {
        return hasClass() ? controller["".concat(name, "Class")].split(" ") : defaultClasses();
      }
    });
  }
  let methods = {
    ["add".concat(pascalCase(name), "Classes")]: function () {
      let element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultElement;
      return element.classList.add(...classOrDefault());
    },
    ["remove".concat(pascalCase(name), "Classes")]: function () {
      let element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultElement;
      return element.classList.remove(...classOrDefault());
    },
    ["".concat(name, "ClassesPresent")]: function () {
      let element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultElement;
      return classOrDefault().every(function (klass) {
        return element.classList.contains(klass);
      });
    }
  };
  console.log(methods);
  Object.assign(controller, methods);
}
function installClassMethods(controller) {
  let classes = controller.constructor.classes || [];
  console.log(classes);
  classes.forEach(function (classDefinition) {
    return addMethodsForClassDefinition(controller, classDefinition);
  });
}
class CharCountController extends BaseController {
  connect() {
    var _this7 = this;
    installClassMethods(this);
    requestAnimationFrame(function () {
      useEventListener(_this7, _this7.inputTarget, "input", _this7._updateCharCount);
      _this7._updateCharCount();
    });
  }
  _updateCharCount() {
    let charCount = this.inputTarget.value.length;
    this.outputTarget.innerText = charCount.toString();
    if (this._isValidCount(charCount)) {
      this.removeErrorClasses(this.outputTarget);
    } else {
      this.addErrorClasses(this.outputTarget);
    }
  }
  _isValidCount(count) {
    let min = 0;
    let max = 99999;
    if (this.hasMinValue) {
      min = this.minValue;
    }
    if (this.hasMaxValue) {
      max = this.maxValue;
    }
    return count >= min && count <= max;
  }
}
__publicField(CharCountController, "targets", ["input", "output"]);
__publicField(CharCountController, "values", {
  min: Number,
  max: Number
});
__publicField(CharCountController, "classes", ["error"]);
class CheckboxDisableInputsController extends BaseController {
  connect() {
    this.toggle();
  }
  toggle() {
    if (this.hasDisablerTarget && this.disablerTarget.checked) {
      this.disable();
    } else {
      this.enable();
    }
  }
  disable() {
    let shouldClear = this.hasClearValue && this.clearValue;
    this.disableTargets.forEach(function (el, _) {
      if (shouldClear) {
        el.value = "";
      }
      el.disabled = true;
    });
  }
  enable() {
    this.disableTargets.forEach(function (el, _) {
      el.disabled = false;
    });
  }
}
__publicField(CheckboxDisableInputsController, "targets", ["disabler", "disable"]);
__publicField(CheckboxDisableInputsController, "values", {
  clear: Boolean
});
class CheckboxEnableInputsController extends BaseController {
  connect() {
    this.toggle();
  }
  toggle() {
    if (this.hasEnablerTarget && this.enablerTarget.checked) {
      this.enable();
    } else {
      this.disable();
    }
  }
  disable() {
    let shouldClear = this.hasClearValue && this.clearValue;
    this.enableTargets.forEach(function (el, _) {
      if (shouldClear) {
        el.value = "";
      }
      el.disabled = true;
    });
  }
  enable() {
    this.enableTargets.forEach(function (el, _) {
      el.disabled = false;
    });
  }
}
__publicField(CheckboxEnableInputsController, "targets", ["enabler", "enable"]);
__publicField(CheckboxEnableInputsController, "values", {
  clear: Boolean
});
class CheckboxSelectAllController extends BaseController {
  get _checked() {
    return this._enabled.filter(function (checkbox) {
      return checkbox.checked;
    });
  }
  get _enabled() {
    return this.checkboxTargets.filter(function (checkbox) {
      return !checkbox.disabled && !checkbox.readOnly;
    });
  }
  get _unchecked() {
    return this._enabled.filter(function (checkbox) {
      return !checkbox.checked;
    });
  }
  connect() {
    var _this8 = this;
    requestAnimationFrame(function () {
      if (!_this8.hasSelectAllTarget) {
        return;
      }
      useEventListener(_this8, _this8.selectAllTarget, "change", _this8._toggle);
      useCollectionEventListener(_this8, _this8.checkboxTargets, "change", _this8._refresh);
      _this8._refresh();
    });
  }
  _toggle(event) {
    event.preventDefault();
    let target = event.target;
    this._enabled.forEach(function (checkbox) {
      return checkbox.checked = checkbox.disabled || checkbox.readOnly ? checkbox.checked : target.checked;
    });
  }
  _refresh() {
    const checkboxesCount = this._enabled.length;
    const checkboxesCheckedCount = this._checked.length;
    this.selectAllTarget.checked = checkboxesCheckedCount > 0;
    this.selectAllTarget.indeterminate = checkboxesCheckedCount > 0 && checkboxesCheckedCount < checkboxesCount;
  }
}
__publicField(CheckboxSelectAllController, "targets", ["selectAll", "checkbox"]);
class CheckboxXORController extends BaseController {
  connect() {
    useCollectionEventListener(this, this.checkboxTargets, "change", this._update);
  }
  _otherCheckboxes(el) {
    return Array.from(this.checkboxTargets).filter(function (field) {
      return field !== el;
    });
  }
  _update(event) {
    var _this9 = this;
    const target = event.target;
    if (!target) {
      throw new Error("No target found on event");
    }
    let others = this._otherCheckboxes(target);
    if (target.checked) {
      others.forEach(function (checkbox) {
        checkbox.checked = false;
        _this9.dispatch(_this9.el, "change");
      });
    }
  }
}
__publicField(CheckboxXORController, "targets", ["checkbox"]);
class DetectDirtyController extends BaseController {
  get _cacheAttrName() {
    return "detect-dirty-load-value";
  }
  connect() {
    let element = this.el;
    this._cacheLoadValues();
    this._checkDirty();
    useEventListener(this, element, ["input", "change"], this._checkDirty, {
      debounce: 10
    });
  }
  restore(event) {
    event == null ? void 0 : event.preventDefault();
    this._restoreElementFromLoadValue();
  }
  _getElementValue() {
    let element = this.el;
    return isElementCheckable(element) ? element.checked : element.value;
  }
  _getElementLoadValue() {
    let element = this.el;
    let value = element.getAttribute(this._cacheAttrName);
    if (isElementCheckable(element)) {
      return value == null ? element.defaultChecked : value == "true";
    } else if (isHTMLSelectElement(element)) {
      let options = Array.from(element.options);
      options.forEach(function (option) {
        if (option.defaultSelected) {
          element.value = option.value;
          return option.value;
        }
      });
    } else if (value !== null) {
      return value;
    }
    return value;
  }
  _elementHasCachedLoadValue() {
    let element = this.el;
    return element.hasAttribute(this._cacheAttrName);
  }
  _checkDirty() {
    let element = this.el;
    if (isHTMLInputElement(element) && element.type == "radio") {
      getOtherRadiosInGroup(element).forEach(function (radio) {
        return radio.removeAttribute("data-dirty");
      });
    }
    if (this._isElementDirty()) {
      element.setAttribute("data-dirty", "true");
    } else {
      element.removeAttribute("data-dirty");
    }
  }
  _isElementDirty() {
    return this._getElementValue() !== this._getElementLoadValue();
  }
  _restoreElementFromLoadValue() {
    let element = this.el;
    let cacheValue = element.getAttribute(this._cacheAttrName);
    if (isElementCheckable(element)) {
      element.setAttribute(this._cacheAttrName, element.checked.toString());
      element.checked = cacheValue == null ? element.defaultChecked : cacheValue == "true";
    } else if (isHTMLSelectElement(element)) {
      if (cacheValue == null) {
        let options = Array.from(element.options);
        options.forEach(function (option) {
          if (option.defaultSelected) {
            element.value = option.value;
            return;
          }
        });
      } else {
        element.value = cacheValue;
      }
    } else {
      element.value = cacheValue == null ? element.defaultValue : cacheValue;
    }
  }
  _cacheLoadValues() {
    let element = this.el;
    if (!this._elementHasCachedLoadValue() && isElementCheckable(element)) {
      element.setAttribute(this._cacheAttrName, element.checked.toString());
    } else {
      element.setAttribute(this._cacheAttrName, element.value.toString());
    }
  }
}
function isDirty(element) {
  return element.hasAttribute("data-dirty");
}
class DetectDirtyFormController extends BaseController {
  get _formElements() {
    return Array.from(this.el.querySelectorAll("input, select, textarea"));
  }
  get _cacheAttrName() {
    return "detect-dirty-load-value";
  }
  connect() {
    let element = this.el;
    this._cacheLoadValues();
    this._checkDirty();
    useEventListener(this, element, ["input", "change"], this._checkDirty, {
      debounce: 10
    });
  }
  restore(event) {
    var _this10 = this;
    event == null ? void 0 : event.preventDefault();
    this._formElements.forEach(function (element) {
      return _this10._restoreElementFromLoadValue(element);
    });
  }
  _getElementValue(element) {
    return isElementCheckable(element) ? element.checked : element.value;
  }
  _getElementLoadValue(element) {
    let value = element.getAttribute(this._cacheAttrName);
    if (isElementCheckable(element)) {
      return value == null ? element.defaultChecked : value == "true";
    } else if (isHTMLSelectElement(element)) {
      let options = Array.from(element.options);
      options.forEach(function (option) {
        if (option.defaultSelected) {
          element.value = option.value;
          return option.value;
        }
      });
    } else if (value !== null) {
      return value;
    }
    return value;
  }
  _elementHasCachedLoadValue(element) {
    return element.hasAttribute(this._cacheAttrName);
  }
  _checkElementDirty(element) {
    if (isHTMLInputElement(element) && element.type == "radio") {
      getOtherRadiosInGroup(element).forEach(function (radio) {
        return radio.removeAttribute("data-dirty");
      });
    }
    if (this._isElementDirty(element)) {
      element.setAttribute("data-dirty", "true");
    } else {
      element.removeAttribute("data-dirty");
    }
  }
  _isElementDirty(element) {
    return this._getElementValue(element) !== this._getElementLoadValue(element);
  }
  _cacheElementLoadValue(element) {
    if (!this._elementHasCachedLoadValue(element) && isElementCheckable(element)) {
      element.setAttribute(this._cacheAttrName, element.checked.toString());
    } else {
      element.setAttribute(this._cacheAttrName, element.value.toString());
    }
  }
  _restoreElementFromLoadValue(element) {
    let cacheValue = element.getAttribute(this._cacheAttrName);
    if (isElementCheckable(element)) {
      element.setAttribute(this._cacheAttrName, element.checked.toString());
      element.checked = cacheValue == null ? element.defaultChecked : cacheValue == "true";
    } else if (isHTMLSelectElement(element)) {
      if (cacheValue == null) {
        let options = Array.from(element.options);
        options.forEach(function (option) {
          if (option.defaultSelected) {
            element.value = option.value;
            return;
          }
        });
      } else {
        element.value = cacheValue;
      }
    } else {
      element.value = cacheValue == null ? element.defaultValue : cacheValue;
    }
  }
  _cacheLoadValues() {
    var _this11 = this;
    this._formElements.forEach(function (el) {
      return _this11._cacheElementLoadValue(el);
    });
  }
  _checkDirty() {
    var _this12 = this;
    this._formElements.forEach(function (el) {
      return _this12._checkElementDirty(el);
    });
    if (this._formElements.some(function (el) {
      return isFormDirty(el);
    })) {
      this.el.setAttribute("data-dirty", "true");
    } else {
      this.el.removeAttribute("data-dirty");
    }
  }
}
function isFormDirty(element) {
  return element.hasAttribute("data-dirty");
}
class EnableInputsController extends BaseController {
  connect() {}
  disable() {
    let shouldClear = this.hasClearValue && this.clearValue;
    this.inputTargets.forEach(function (el, _) {
      if (shouldClear) {
        el.value = "";
      }
      el.disabled = true;
    });
  }
  enable() {
    this.inputTargets.forEach(function (el, _) {
      return el.disabled = false;
    });
  }
}
__publicField(EnableInputsController, "targets", ["input"]);
__publicField(EnableInputsController, "values", {
  clear: Boolean
});
class FocusStealController extends BaseController {
  get _mode() {
    const MODES = ["immediate", "wait"];
    if (this.hasModeValue) {
      if (!MODES.includes(this.modeValue)) {
        throw new Error("The given modeValue '".concat(this.modeValue, "' is not one of the supported modes: \"").concat(MODES.join('", "'), "\""));
      } else {
        return this.modeValue;
      }
    } else {
      return MODES[0];
    }
  }
  connect() {
    if (this._mode == "immediate") {
      this.steal();
    }
  }
  steal() {
    this.el.focus();
  }
}
__publicField(FocusStealController, "values", {
  mode: String
});
class FormRcController extends BaseController {
  get _mode() {
    if (this.hasSubmitModeValue) {
      if (!["direct", "request"].includes(this.submitModeValue)) {
        throw new Error("The modeValue provided '".concat(this.submitModeValue, "' is not one of the recognised configuration options"));
      }
      return this.submitModeValue;
    } else {
      return "request";
    }
  }
  get form() {
    let form;
    if (this.hasFormSelectorValue) {
      form = document.querySelector(this.formSelectorValue);
      if (!form) {
        throw new Error("Could not find a form on the page that matches selector '".concat(this.formSelectorValue, "'"));
      }
    } else {
      form = this.formTarget;
    }
    return form;
  }
  submit(event) {
    event == null ? void 0 : event.preventDefault();
    let el = this.formTarget;
    if (this._mode == "request") {
      requestSubmit(el);
    } else {
      el.submit();
    }
  }
  reset(event) {
    event == null ? void 0 : event.preventDefault();
    requestReset(this.form);
  }
}
__publicField(FormRcController, "targets", ["form"]);
__publicField(FormRcController, "values", {
  formSelector: String,
  submitMode: String
});
class FormSaveController extends BaseController {
  get _formID() {
    if (this.hasIdValue) {
      return this.idValue;
    }
    let elementID = this.el.id;
    if (elementID !== "") {
      return elementID;
    } else {
      throw new Error("No ID value to uniquely identify this form. Please either specify data-".concat(this.identifier, "-id-value or give this form an 'id' attribute. "));
    }
  }
  get _formIdentifier() {
    const url = location.href;
    return "".concat(url, " ").concat(this._formID);
  }
  get _formElements() {
    return this.el.elements;
  }
  get _formData() {
    let data = {
      [this._formIdentifier]: {}
    };
    for (const element of this._formElements) {
      let el = element;
      if (el.name.length > 0) {
        if (isHTMLInputElement(el) && el.type == "checkbox") {
          data[this._formIdentifier][el.name] = el.checked;
        } else if (isHTMLInputElement(el) && el.type == "radio") {
          if (el.checked) {
            data[this._formIdentifier][el.name] = el.value;
          }
        } else {
          data[this._formIdentifier][el.name] = el.value;
        }
      }
    }
    return data;
  }
  get _restoreOnLoad() {
    return this.hasRestoreOnLoadValue ? this.restoreOnLoadValue : true;
  }
  get _clearOnSubmit() {
    return this.hasClearOnSubmitValue ? this.clearOnSubmitValue : true;
  }
  connect() {
    var _this13 = this;
    requestAnimationFrame(function () {
      let element = _this13.el;
      if (!isHTMLFormElement(element)) {
        throw new Error("Expected controller to be mounted on a form element.");
      }
      if (_this13._restoreOnLoad) {
        _this13.restore();
      }
      if (_this13._clearOnSubmit) {
        useEventListener(_this13, _this13.el, "submit", _this13._clear);
      }
    });
  }
  _clear() {
    localStorage.removeItem(this._formIdentifier);
    this.dispatch(this.el, "form-save:cleared");
  }
  clear(event) {
    event == null ? void 0 : event.preventDefault();
    this._clear();
  }
  save(event) {
    event.preventDefault();
    let data = this._formData;
    localStorage.setItem(this._formIdentifier, JSON.stringify(data[this._formIdentifier]));
    this.dispatch(this.el, "form-save:save:success");
  }
  restore(event) {
    event == null ? void 0 : event.preventDefault();
    if (localStorage.getItem(this._formIdentifier)) {
      const savedData = JSON.parse(localStorage.getItem(this._formIdentifier));
      for (const element of this._formElements) {
        let el = element;
        if (el.name in savedData) {
          if (isHTMLInputElement(el) && el.type == "checkbox") {
            el.checked = savedData[el.name];
          } else if (isHTMLInputElement(el) && el.type == "radio") {
            if (el.value == savedData[el.name]) {
              el.checked = true;
            }
          } else {
            el.value = savedData[el.name];
          }
        }
      }
      this.dispatch(this.el, "form-save:restore:success");
    } else {
      this.dispatch(this.el, "form-save:restore:empty");
    }
  }
}
__publicField(FormSaveController, "values", {
  id: String,
  restoreOnLoad: Boolean,
  clearOnSubmit: Boolean
});
class LimitedSelectionCheckboxesController extends BaseController {
  connect() {
    useCollectionEventListener(this, this.inputTargets, "change", this._handleInputs);
  }
  _handleInputs(event) {
    let tickedInputs = this.inputTargets.reduce(function (previousValue, el) {
      return el.checked ? previousValue + 1 : previousValue;
    }, 0);
    let target = event.target;
    if (tickedInputs > this.maxValue) {
      event.preventDefault();
      target.checked = false;
      this.dispatch(target, "change");
      this.dispatch(target, "limited-selection:too-many");
      if (this.hasErrorTarget && this.hasMessageValue) {
        this.errorTarget.innerHTML = this.messageValue;
      }
    } else {
      this.dispatch(target, "limited-selection:selection");
      if (this.hasErrorTarget) {
        this.errorTarget.innerHTML = "";
      }
    }
  }
}
__publicField(LimitedSelectionCheckboxesController, "targets", ["input", "error"]);
__publicField(LimitedSelectionCheckboxesController, "values", {
  max: Number,
  message: String
});
class NavigateFormErrorsController extends BaseController {
  constructor() {
    super(...arguments);
    __publicField(this, "_errors", []);
    __publicField(this, "_firstClick", false);
  }
  get defaultCurrentClasses() {
    return ["currentError"];
  }
  get _errorCount() {
    return this._errors.length;
  }
  get _previousIndex() {
    let index = this._index - 1;
    if (index < 0) {
      return 0;
    }
    return index;
  }
  get _nextIndex() {
    let index = this._index + 1;
    if (index > this._errors.length - 1) {
      return this._errors.length - 1;
    }
    return index;
  }
  get _index() {
    return clamp(this.hasIndexValue ? this.indexValue : 0, 0, this._errors.length);
  }
  get _selector() {
    if (this.hasSelectorValue) {
      return this.selectorValue;
    } else {
      throw new Error("Expected `selectorValue` to be present");
    }
  }
  get _currentError() {
    return this._errors[this._index];
  }
  get _otherErrors() {
    var _this14 = this;
    return this._errors.filter(function (error, index) {
      return index !== _this14._index;
    });
  }
  connect() {
    var _this15 = this;
    installClassMethods(this);
    requestAnimationFrame(function () {
      _this15._firstClick = true;
      _this15._toggleButtons();
      _this15._toggleVisibility();
    });
  }
  async current(event) {
    event == null ? void 0 : event.preventDefault();
    if (this._firstClick) {
      this._firstClick = false;
      this._toggleButtons();
    }
    await scrollToElement(this._currentError, {
      behavior: "smooth",
      block: "center",
      inline: "center"
    });
    this._updateClasses();
  }
  async next(event) {
    event == null ? void 0 : event.preventDefault();
    if (this._firstClick) {
      this._firstClick = false;
      this._toggleButtons();
    } else {
      this.indexValue = this._nextIndex;
    }
    await scrollToElement(this._currentError, {
      behavior: "smooth",
      block: "center",
      inline: "center"
    });
    this._updateClasses();
  }
  async previous(event) {
    event == null ? void 0 : event.preventDefault();
    if (this._firstClick) {
      this._firstClick = false;
      this._toggleButtons();
    } else {
      this.indexValue = this._previousIndex;
    }
    await scrollToElement(this._currentError, {
      behavior: "smooth",
      block: "center",
      inline: "center"
    });
    this._updateClasses();
  }
  indexValueChanged() {
    this._toggleButtons();
  }
  selectorValueChanged() {
    this._errors = Array.from(document.querySelectorAll(this._selector));
    this.indexValue = 0;
    this._toggleButtons();
    this._toggleVisibility();
  }
  _updateClasses() {
    var _this16 = this;
    this.addCurrentClasses(this._currentError);
    this._otherErrors.forEach(function (error) {
      return _this16.removeCurrentClasses(error);
    });
  }
  _toggleVisibility() {
    if (this._errorCount === 0) {
      this.el.style.display = "none";
    } else {
      this.el.style.display = "";
    }
  }
  _toggleButtons() {
    if (this.hasNextTarget) {
      if (!this.hasCurrentTarget && this._firstClick && this.indexValue == this._errorCount - 1) {
        this.nextTarget.removeAttribute("disabled");
        return;
      } else if (this.indexValue >= this._errorCount - 1) {
        this.nextTarget.setAttribute("disabled", "true");
      } else {
        this.nextTarget.removeAttribute("disabled");
      }
    }
    if (this.hasPreviousTarget) {
      if (this.indexValue <= 0) {
        this.previousTarget.setAttribute("disabled", "true");
      } else {
        this.previousTarget.removeAttribute("disabled");
      }
    }
  }
}
__publicField(NavigateFormErrorsController, "values", {
  selector: String,
  index: Number
});
__publicField(NavigateFormErrorsController, "classes", ["current"]);
__publicField(NavigateFormErrorsController, "targets", ["next", "current", "previous"]);
class NestedFormController extends BaseController {
  get _wrapperClass() {
    return this.hasWrapperSelectorValue ? this.wrapperClassValue : "nested-fields";
  }
  get _insertMode() {
    return this.hasInsertModeValue ? this.insertModeValue : "beforeend";
  }
  connect() {
    this._checkStructure();
  }
  add(event) {
    event == null ? void 0 : event.preventDefault();
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, this._generateID());
    this.targetTarget.insertAdjacentHTML(this._insertMode, content);
  }
  remove(event) {
    event.preventDefault();
    const wrapper = event.target.closest(".".concat(this._wrapperClass));
    if (wrapper == null) {
      throw new Error("#remove was clicked from outside of a child record. Could not find an ancestor with class .".concat(this._wrapperClass));
    }
    if (wrapper.dataset.newRecord === "true") {
      wrapper.remove();
    } else {
      wrapper.style.display = "none";
      let destroyInput = wrapper.querySelector("input[name*='_destroy']");
      if (destroyInput == null) {
        throw new Error("Could not find a hidden input with name '_destroy'. NestedForm cannot remove an already persisted record without it.");
      }
      destroyInput.value = "1";
    }
  }
  _generateID() {
    return new Date().getTime().toString() + Math.random().toString().slice(2);
  }
  _checkStructure() {
    let template = this.templateTarget.innerHTML;
    if (template.indexOf("NEW_RECORD")) {
      throw new Error("Could not find 'NEW_RECORD' in the provided template. Please make sure you've passed `child_index: 'NEW_RECORD'` to `fields_for`");
    }
  }
}
__publicField(NestedFormController, "targets", ["target", "template"]);
__publicField(NestedFormController, "values", {
  insertMode: String,
  wrapperClass: String
});
class PasswordConfirmController extends BaseController {
  connect() {
    installClassMethods(this);
    useCollectionEventListener(this, this.passwordTargets, "change", this._checkPasswordsMatch);
  }
  _allPasswordsMatch() {
    let values = new Set(this.passwordTargets.map(function (el) {
      return el.value;
    }));
    return values.has("") || values.size == 1;
  }
  _checkPasswordsMatch() {
    var _this17 = this;
    let element = this.el;
    if (this._allPasswordsMatch()) {
      this.dispatch(element, "password-confirm:match");
      this.passwordTargets.forEach(function (el) {
        return _this17.removeErrorClasses(el);
      });
    } else {
      this.dispatch(element, "password-confirm:no-match");
      this.passwordTargets.forEach(function (el) {
        return _this17.addErrorClasses(el);
      });
    }
  }
}
__publicField(PasswordConfirmController, "targets", ["password"]);
__publicField(PasswordConfirmController, "classes", ["error"]);
class PasswordPeekController extends BaseController {
  peak(event) {
    event == null ? void 0 : event.preventDefault();
    this.passwordTarget.type = "text";
  }
  hide(event) {
    event == null ? void 0 : event.preventDefault();
    this.passwordTarget.type = "password";
  }
  toggle(event) {
    event == null ? void 0 : event.preventDefault();
    if (this.passwordTarget.type === "password") {
      this.peak();
    } else {
      this.hide();
    }
  }
}
__publicField(PasswordPeekController, "targets", ["password"]);
class RemoteFormController extends BaseController {
  get _selector() {
    return this.hasSelectorValue ? this.selectorValue : "[data-controller~=\"".concat(this.identifier, "\"]");
  }
  replace(event) {
    const _event$detail = _slicedToArray(event.detail, 3),
      data = _event$detail[0],
      status = _event$detail[1],
      xhr = _event$detail[2];
    if (data instanceof Node) {
      let newElement = data.querySelector(this._selector);
      if (newElement == null) {
        throw new Error("expected new form DOM with [data-controller=\"".concat(this.identifier, "\"] to be present in returned payload"));
      }
      let parentNode = this.el.parentNode;
      if (parentNode == null) {
        throw new Error("expected form to have a DOM parent, could not execute replaceChild");
      }
      parentNode.replaceChild(newElement, this.el);
      this.dispatch(newElement, "remote-form:replace");
    } else {
      console.log("Unknown", data);
    }
  }
}
__publicField(RemoteFormController, "targets", []);
__publicField(RemoteFormController, "values", {
  selector: String
});
function useEventBus(controller, eventNameOrNames, handler, opts) {
  let options = opts;
  if (options == null ? void 0 : options.debounce) {
    handler = debounce(handler.bind(controller), options.debounce);
    delete options.debounce;
  } else {
    handler = handler.bind(controller);
  }
  let eventNames = wrapArray(eventNameOrNames);
  let setup = function () {
    return eventNames.forEach(function (eventName) {
      return EventBus.on(eventName, handler);
    });
  };
  let teardown = function () {
    return eventNames.forEach(function (eventName) {
      return EventBus.off(eventName, handler);
    });
  };
  useMixin(controller, setup, teardown);
  return {
    setup,
    teardown
  };
}
class SyncInputsController extends BaseController {
  get _eventName() {
    return "sync:".concat(this._key);
  }
  get _key() {
    if (this.hasKeyValue) {
      return this.keyValue;
    }
    throw new Error("Expected `keyValue` to be present");
  }
  get _value() {
    let el = this.el;
    if (isHTMLInputElement(el) && el.type === "checkbox") {
      return el.checked;
    } else if (isHTMLInputElement(el) && el.type === "radio") {
      return el.checked ? el.value : "";
    } else {
      return el.value;
    }
  }
  set _value(val) {
    let el = this.el;
    if (isHTMLInputElement(el) && el.type === "checkbox") {
      el.checked = val.toString() === "true";
    } else if (isHTMLInputElement(el) && el.type === "radio") {
      el.checked = el.value === val;
    } else if (isHTMLInputElement(el) || isHTMLTextAreaElement(el) || isHTMLSelectElement(el)) {
      el.value = val.toString();
    } else {
      el.innerHTML = val.toString();
    }
  }
  connect() {
    var _this18 = this;
    useEventBus(this, this._eventName, this._read);
    requestAnimationFrame(function () {
      if (isTypeOfFormInputElement(_this18.el)) {
        _this18._emit();
        useEventListener(_this18, _this18.el, "input", _this18._emit);
      }
    });
  }
  _emit() {
    EventBus.emit(this._eventName, {
      value: this._value,
      dispatcher: this.el
    });
  }
  _read(payload) {
    if (payload === void 0) {
      throw new Error("No payload received");
    }
    let dispatcher = payload.dispatcher,
      value = payload.value;
    if (dispatcher !== this.el) {
      this._value = value;
    }
  }
}
__publicField(SyncInputsController, "values", {
  key: String
});
class ValueWarnController extends BaseController {
  get _maxMessage() {
    return this.hasMaxMessageValue ? this.maxMessageValue : "Value must be less than ".concat(this.maxValue);
  }
  get _minMessage() {
    return this.hasMinMessageValue ? this.minMessageValue : "Value must be greater than ".concat(this.minValue);
  }
  get defaultWarningHideClasses() {
    return ["hide"];
  }
  connect() {
    installClassMethods(this);
    this.addWarningHideClasses(this.warningTarget);
    useEventListener(this, this.inputTarget, "input", this._check);
    this._check();
  }
  _check() {
    if (this.hasMinValue && Number.parseFloat(this.inputTarget.value) < this.minValue) {
      this.removeWarningHideClasses(this.warningTarget);
      this.addInputWarningClasses(this.inputTarget);
      this.warningTarget.innerText = this._minMessage;
    } else if (this.hasMaxValue && Number.parseFloat(this.inputTarget.value) > this.maxValue) {
      this.removeWarningHideClasses(this.warningTarget);
      this.addInputWarningClasses(this.inputTarget);
      this.warningTarget.innerText = this._maxMessage;
    } else {
      this.addWarningHideClasses(this.warningTarget);
      this.removeInputWarningClasses(this.inputTarget);
      this.warningTarget.innerText = "";
    }
  }
}
__publicField(ValueWarnController, "classes", ["inputWarning", "warningHide"]);
__publicField(ValueWarnController, "targets", ["input", "warning"]);
__publicField(ValueWarnController, "values", {
  max: Number,
  min: Number,
  minMessage: String,
  maxMessage: String
});
class WordCountController extends BaseController {
  connect() {
    installClassMethods(this);
    this._updateWordCount();
    useEventListener(this, this.inputTarget, "input", this._updateWordCount);
  }
  _updateWordCount() {
    let wordCount = 0;
    let textAreaValue = this.inputTarget.value;
    let matches = textAreaValue.match(/\S+/g);
    wordCount = matches && matches.length || 0;
    this.outputTarget.innerText = wordCount.toString();
    if (this._isValidCount(wordCount)) {
      this.removeErrorClasses(this.outputTarget);
    } else {
      this.addErrorClasses(this.outputTarget);
    }
  }
  _isValidCount(count) {
    let min = 0;
    let max = 99999;
    if (this.hasMinValue) {
      min = this.minValue;
    }
    if (this.hasMaxValue) {
      max = this.maxValue;
    }
    return count >= min && count <= max;
  }
}
__publicField(WordCountController, "targets", ["input", "output"]);
__publicField(WordCountController, "values", {
  min: Number,
  max: Number
});
__publicField(WordCountController, "classes", ["error"]);
class FallbackImageController extends BaseController {
  initialize() {
    this._hasLoadedSuccessfully = this._hasLoadedSuccessfully.bind(this);
    this._success = this._success.bind(this);
    this._fail = this._fail.bind(this);
  }
  connect() {
    let element = this.el;
    element.onerror = this._fail;
    if (element.complete && !this._hasLoadedSuccessfully()) {
      this._fail();
    } else {
      this._success();
    }
  }
  disconnect() {
    this.removeSuccessClasses();
    this.removeFailClasses();
  }
  _success() {
    this.addSuccessClasses();
  }
  _fail() {
    let element = this.el;
    this.addFailClasses();
    if (this.hasPlaceholderValue && element.src !== this.placeholderValue) {
      this.dispatch(element, "fallback-image:placeholder");
      element.src = this.placeholderValue;
      element.onerror = this._fail;
    } else {
      this.dispatch(element, "fallback-image:fail");
      element.style.display = "none";
    }
  }
  _hasLoadedSuccessfully() {
    let element = this.el;
    return element.naturalHeight > 0 && element.naturalWidth > 0;
  }
}
__publicField(FallbackImageController, "values", {
  placeholder: String
});
__publicField(FallbackImageController, "classes", ["success", "fail"]);
var supportCustomEvent = window.CustomEvent;
if (!supportCustomEvent || typeof supportCustomEvent === "object") {
  supportCustomEvent = function CustomEvent2(event, x) {
    x = x || {};
    var ev = document.createEvent("CustomEvent");
    ev.initCustomEvent(event, !!x.bubbles, !!x.cancelable, x.detail || null);
    return ev;
  };
  supportCustomEvent.prototype = window.Event.prototype;
}
function safeDispatchEvent(target, event) {
  var check = "on" + event.type.toLowerCase();
  if (typeof target[check] === "function") {
    target[check](event);
  }
  return target.dispatchEvent(event);
}
function createsStackingContext(el) {
  while (el && el !== document.body) {
    var s = window.getComputedStyle(el);
    var invalid = function (k, ok) {
      return !(s[k] === void 0 || s[k] === ok);
    };
    if (s.opacity < 1 || invalid("zIndex", "auto") || invalid("transform", "none") || invalid("mixBlendMode", "normal") || invalid("filter", "none") || invalid("perspective", "none") || s["isolation"] === "isolate" || s.position === "fixed" || s.webkitOverflowScrolling === "touch") {
      return true;
    }
    el = el.parentElement;
  }
  return false;
}
function findNearestDialog(el) {
  while (el) {
    if (el.localName === "dialog") {
      return el;
    }
    if (el.parentElement) {
      el = el.parentElement;
    } else if (el.parentNode) {
      el = el.parentNode.host;
    } else {
      el = null;
    }
  }
  return null;
}
function safeBlur(el) {
  while (el && el.shadowRoot && el.shadowRoot.activeElement) {
    el = el.shadowRoot.activeElement;
  }
  if (el && el.blur && el !== document.body) {
    el.blur();
  }
}
function inNodeList(nodeList, node) {
  for (var i = 0; i < nodeList.length; ++i) {
    if (nodeList[i] === node) {
      return true;
    }
  }
  return false;
}
function isFormMethodDialog(el) {
  if (!el || !el.hasAttribute("method")) {
    return false;
  }
  return el.getAttribute("method").toLowerCase() === "dialog";
}
function findFocusableElementWithin(hostElement) {
  var opts = ["button", "input", "keygen", "select", "textarea"];
  var query = opts.map(function (el) {
    return el + ":not([disabled])";
  });
  query.push('[tabindex]:not([disabled]):not([tabindex=""])');
  var target = hostElement.querySelector(query.join(", "));
  if (!target && "attachShadow" in Element.prototype) {
    var elems = hostElement.querySelectorAll("*");
    for (var i = 0; i < elems.length; i++) {
      if (elems[i].tagName && elems[i].shadowRoot) {
        target = findFocusableElementWithin(elems[i].shadowRoot);
        if (target) {
          break;
        }
      }
    }
  }
  return target;
}
function isConnected(element) {
  return element.isConnected || document.body.contains(element);
}
function findFormSubmitter(event) {
  if (event.submitter) {
    return event.submitter;
  }
  var form = event.target;
  if (!(form instanceof HTMLFormElement)) {
    return null;
  }
  var submitter = dialogPolyfill.formSubmitter;
  if (!submitter) {
    var target = event.target;
    var root = "getRootNode" in target && target.getRootNode() || document;
    submitter = root.activeElement;
  }
  if (!submitter || submitter.form !== form) {
    return null;
  }
  return submitter;
}
function maybeHandleSubmit(event) {
  if (event.defaultPrevented) {
    return;
  }
  var form = event.target;
  var value = dialogPolyfill.imagemapUseValue;
  var submitter = findFormSubmitter(event);
  if (value === null && submitter) {
    value = submitter.value;
  }
  var dialog = findNearestDialog(form);
  if (!dialog) {
    return;
  }
  var formmethod = submitter && submitter.getAttribute("formmethod") || form.getAttribute("method");
  if (formmethod !== "dialog") {
    return;
  }
  event.preventDefault();
  if (value != null) {
    dialog.close(value);
  } else {
    dialog.close();
  }
}
function dialogPolyfillInfo(dialog) {
  this.dialog_ = dialog;
  this.replacedStyleTop_ = false;
  this.openAsModal_ = false;
  if (!dialog.hasAttribute("role")) {
    dialog.setAttribute("role", "dialog");
  }
  dialog.show = this.show.bind(this);
  dialog.showModal = this.showModal.bind(this);
  dialog.close = this.close.bind(this);
  dialog.addEventListener("submit", maybeHandleSubmit, false);
  if (!("returnValue" in dialog)) {
    dialog.returnValue = "";
  }
  if ("MutationObserver" in window) {
    var mo = new MutationObserver(this.maybeHideModal.bind(this));
    mo.observe(dialog, {
      attributes: true,
      attributeFilter: ["open"]
    });
  } else {
    var removed = false;
    var cb = function () {
      removed ? this.downgradeModal() : this.maybeHideModal();
      removed = false;
    }.bind(this);
    var timeout;
    var delayModel = function (ev) {
      if (ev.target !== dialog) {
        return;
      }
      var cand = "DOMNodeRemoved";
      removed |= ev.type.substr(0, cand.length) === cand;
      window.clearTimeout(timeout);
      timeout = window.setTimeout(cb, 0);
    };
    ["DOMAttrModified", "DOMNodeRemoved", "DOMNodeRemovedFromDocument"].forEach(function (name) {
      dialog.addEventListener(name, delayModel);
    });
  }
  Object.defineProperty(dialog, "open", {
    set: this.setOpen.bind(this),
    get: dialog.hasAttribute.bind(dialog, "open")
  });
  this.backdrop_ = document.createElement("div");
  this.backdrop_.className = "backdrop";
  this.backdrop_.addEventListener("mouseup", this.backdropMouseEvent_.bind(this));
  this.backdrop_.addEventListener("mousedown", this.backdropMouseEvent_.bind(this));
  this.backdrop_.addEventListener("click", this.backdropMouseEvent_.bind(this));
}
dialogPolyfillInfo.prototype = {
  get dialog() {
    return this.dialog_;
  },
  maybeHideModal: function () {
    if (this.dialog_.hasAttribute("open") && isConnected(this.dialog_)) {
      return;
    }
    this.downgradeModal();
  },
  downgradeModal: function () {
    if (!this.openAsModal_) {
      return;
    }
    this.openAsModal_ = false;
    this.dialog_.style.zIndex = "";
    if (this.replacedStyleTop_) {
      this.dialog_.style.top = "";
      this.replacedStyleTop_ = false;
    }
    this.backdrop_.parentNode && this.backdrop_.parentNode.removeChild(this.backdrop_);
    dialogPolyfill.dm.removeDialog(this);
  },
  setOpen: function (value) {
    if (value) {
      this.dialog_.hasAttribute("open") || this.dialog_.setAttribute("open", "");
    } else {
      this.dialog_.removeAttribute("open");
      this.maybeHideModal();
    }
  },
  backdropMouseEvent_: function (e) {
    if (!this.dialog_.hasAttribute("tabindex")) {
      var fake = document.createElement("div");
      this.dialog_.insertBefore(fake, this.dialog_.firstChild);
      fake.tabIndex = -1;
      fake.focus();
      this.dialog_.removeChild(fake);
    } else {
      this.dialog_.focus();
    }
    var redirectedEvent = document.createEvent("MouseEvents");
    redirectedEvent.initMouseEvent(e.type, e.bubbles, e.cancelable, window, e.detail, e.screenX, e.screenY, e.clientX, e.clientY, e.ctrlKey, e.altKey, e.shiftKey, e.metaKey, e.button, e.relatedTarget);
    this.dialog_.dispatchEvent(redirectedEvent);
    e.stopPropagation();
  },
  focus_: function () {
    var target = this.dialog_.querySelector("[autofocus]:not([disabled])");
    if (!target && this.dialog_.tabIndex >= 0) {
      target = this.dialog_;
    }
    if (!target) {
      target = findFocusableElementWithin(this.dialog_);
    }
    safeBlur(document.activeElement);
    target && target.focus();
  },
  updateZIndex: function (dialogZ, backdropZ) {
    if (dialogZ < backdropZ) {
      throw new Error("dialogZ should never be < backdropZ");
    }
    this.dialog_.style.zIndex = dialogZ;
    this.backdrop_.style.zIndex = backdropZ;
  },
  show: function () {
    if (!this.dialog_.open) {
      this.setOpen(true);
      this.focus_();
    }
  },
  showModal: function () {
    if (this.dialog_.hasAttribute("open")) {
      throw new Error("Failed to execute 'showModal' on dialog: The element is already open, and therefore cannot be opened modally.");
    }
    if (!isConnected(this.dialog_)) {
      throw new Error("Failed to execute 'showModal' on dialog: The element is not in a Document.");
    }
    if (!dialogPolyfill.dm.pushDialog(this)) {
      throw new Error("Failed to execute 'showModal' on dialog: There are too many open modal dialogs.");
    }
    if (createsStackingContext(this.dialog_.parentElement)) {
      console.warn("A dialog is being shown inside a stacking context. This may cause it to be unusable. For more information, see this link: https://github.com/GoogleChrome/dialog-polyfill/#stacking-context");
    }
    this.setOpen(true);
    this.openAsModal_ = true;
    if (dialogPolyfill.needsCentering(this.dialog_)) {
      dialogPolyfill.reposition(this.dialog_);
      this.replacedStyleTop_ = true;
    } else {
      this.replacedStyleTop_ = false;
    }
    this.dialog_.parentNode.insertBefore(this.backdrop_, this.dialog_.nextSibling);
    this.focus_();
  },
  close: function (opt_returnValue) {
    if (!this.dialog_.hasAttribute("open")) {
      throw new Error("Failed to execute 'close' on dialog: The element does not have an 'open' attribute, and therefore cannot be closed.");
    }
    this.setOpen(false);
    if (opt_returnValue !== void 0) {
      this.dialog_.returnValue = opt_returnValue;
    }
    var closeEvent = new supportCustomEvent("close", {
      bubbles: false,
      cancelable: false
    });
    safeDispatchEvent(this.dialog_, closeEvent);
  }
};
var dialogPolyfill = {};
dialogPolyfill.reposition = function (element) {
  var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
  var topValue = scrollTop + (window.innerHeight - element.offsetHeight) / 2;
  element.style.top = Math.max(scrollTop, topValue) + "px";
};
dialogPolyfill.isInlinePositionSetByStylesheet = function (element) {
  for (var i = 0; i < document.styleSheets.length; ++i) {
    var styleSheet = document.styleSheets[i];
    var cssRules = null;
    try {
      cssRules = styleSheet.cssRules;
    } catch (e) {}
    if (!cssRules) {
      continue;
    }
    for (var j = 0; j < cssRules.length; ++j) {
      var rule = cssRules[j];
      var selectedNodes = null;
      try {
        selectedNodes = document.querySelectorAll(rule.selectorText);
      } catch (e) {}
      if (!selectedNodes || !inNodeList(selectedNodes, element)) {
        continue;
      }
      var cssTop = rule.style.getPropertyValue("top");
      var cssBottom = rule.style.getPropertyValue("bottom");
      if (cssTop && cssTop !== "auto" || cssBottom && cssBottom !== "auto") {
        return true;
      }
    }
  }
  return false;
};
dialogPolyfill.needsCentering = function (dialog) {
  var computedStyle = window.getComputedStyle(dialog);
  if (computedStyle.position !== "absolute") {
    return false;
  }
  if (dialog.style.top !== "auto" && dialog.style.top !== "" || dialog.style.bottom !== "auto" && dialog.style.bottom !== "") {
    return false;
  }
  return !dialogPolyfill.isInlinePositionSetByStylesheet(dialog);
};
dialogPolyfill.forceRegisterDialog = function (element) {
  if (window.HTMLDialogElement || element.showModal) {
    console.warn("This browser already supports <dialog>, the polyfill may not work correctly", element);
  }
  if (element.localName !== "dialog") {
    throw new Error("Failed to register dialog: The element is not a dialog.");
  }
  new dialogPolyfillInfo(element);
};
dialogPolyfill.registerDialog = function (element) {
  if (!element.showModal) {
    dialogPolyfill.forceRegisterDialog(element);
  }
};
dialogPolyfill.DialogManager = function () {
  this.pendingDialogStack = [];
  var checkDOM = this.checkDOM_.bind(this);
  this.overlay = document.createElement("div");
  this.overlay.className = "_dialog_overlay";
  this.overlay.addEventListener("click", function (e) {
    this.forwardTab_ = void 0;
    e.stopPropagation();
    checkDOM([]);
  }.bind(this));
  this.handleKey_ = this.handleKey_.bind(this);
  this.handleFocus_ = this.handleFocus_.bind(this);
  this.zIndexLow_ = 1e5;
  this.zIndexHigh_ = 1e5 + 150;
  this.forwardTab_ = void 0;
  if ("MutationObserver" in window) {
    this.mo_ = new MutationObserver(function (records) {
      var removed = [];
      records.forEach(function (rec) {
        for (var i = 0, c; c = rec.removedNodes[i]; ++i) {
          if (!(c instanceof Element)) {
            continue;
          } else if (c.localName === "dialog") {
            removed.push(c);
          }
          removed = removed.concat(c.querySelectorAll("dialog"));
        }
      });
      removed.length && checkDOM(removed);
    });
  }
};
dialogPolyfill.DialogManager.prototype.blockDocument = function () {
  document.documentElement.addEventListener("focus", this.handleFocus_, true);
  document.addEventListener("keydown", this.handleKey_);
  this.mo_ && this.mo_.observe(document, {
    childList: true,
    subtree: true
  });
};
dialogPolyfill.DialogManager.prototype.unblockDocument = function () {
  document.documentElement.removeEventListener("focus", this.handleFocus_, true);
  document.removeEventListener("keydown", this.handleKey_);
  this.mo_ && this.mo_.disconnect();
};
dialogPolyfill.DialogManager.prototype.updateStacking = function () {
  var zIndex = this.zIndexHigh_;
  for (var i = 0, dpi; dpi = this.pendingDialogStack[i]; ++i) {
    dpi.updateZIndex(--zIndex, --zIndex);
    if (i === 0) {
      this.overlay.style.zIndex = --zIndex;
    }
  }
  var last = this.pendingDialogStack[0];
  if (last) {
    var p = last.dialog.parentNode || document.body;
    p.appendChild(this.overlay);
  } else if (this.overlay.parentNode) {
    this.overlay.parentNode.removeChild(this.overlay);
  }
};
dialogPolyfill.DialogManager.prototype.containedByTopDialog_ = function (candidate) {
  while (candidate = findNearestDialog(candidate)) {
    for (var i = 0, dpi; dpi = this.pendingDialogStack[i]; ++i) {
      if (dpi.dialog === candidate) {
        return i === 0;
      }
    }
    candidate = candidate.parentElement;
  }
  return false;
};
dialogPolyfill.DialogManager.prototype.handleFocus_ = function (event) {
  var target = event.composedPath ? event.composedPath()[0] : event.target;
  if (this.containedByTopDialog_(target)) {
    return;
  }
  if (document.activeElement === document.documentElement) {
    return;
  }
  event.preventDefault();
  event.stopPropagation();
  safeBlur(target);
  if (this.forwardTab_ === void 0) {
    return;
  }
  var dpi = this.pendingDialogStack[0];
  var dialog = dpi.dialog;
  var position = dialog.compareDocumentPosition(target);
  if (position & Node.DOCUMENT_POSITION_PRECEDING) {
    if (this.forwardTab_) {
      dpi.focus_();
    } else if (target !== document.documentElement) {
      document.documentElement.focus();
    }
  }
  return false;
};
dialogPolyfill.DialogManager.prototype.handleKey_ = function (event) {
  this.forwardTab_ = void 0;
  if (event.keyCode === 27) {
    event.preventDefault();
    event.stopPropagation();
    var cancelEvent = new supportCustomEvent("cancel", {
      bubbles: false,
      cancelable: true
    });
    var dpi = this.pendingDialogStack[0];
    if (dpi && safeDispatchEvent(dpi.dialog, cancelEvent)) {
      dpi.dialog.close();
    }
  } else if (event.keyCode === 9) {
    this.forwardTab_ = !event.shiftKey;
  }
};
dialogPolyfill.DialogManager.prototype.checkDOM_ = function (removed) {
  var clone = this.pendingDialogStack.slice();
  clone.forEach(function (dpi) {
    if (removed.indexOf(dpi.dialog) !== -1) {
      dpi.downgradeModal();
    } else {
      dpi.maybeHideModal();
    }
  });
};
dialogPolyfill.DialogManager.prototype.pushDialog = function (dpi) {
  var allowed = (this.zIndexHigh_ - this.zIndexLow_) / 2 - 1;
  if (this.pendingDialogStack.length >= allowed) {
    return false;
  }
  if (this.pendingDialogStack.unshift(dpi) === 1) {
    this.blockDocument();
  }
  this.updateStacking();
  return true;
};
dialogPolyfill.DialogManager.prototype.removeDialog = function (dpi) {
  var index = this.pendingDialogStack.indexOf(dpi);
  if (index === -1) {
    return;
  }
  this.pendingDialogStack.splice(index, 1);
  if (this.pendingDialogStack.length === 0) {
    this.unblockDocument();
  }
  this.updateStacking();
};
dialogPolyfill.dm = new dialogPolyfill.DialogManager();
dialogPolyfill.formSubmitter = null;
dialogPolyfill.imagemapUseValue = null;
if (window.HTMLDialogElement === void 0) {
  var testForm = document.createElement("form");
  testForm.setAttribute("method", "dialog");
  if (testForm.method !== "dialog") {
    var methodDescriptor = Object.getOwnPropertyDescriptor(HTMLFormElement.prototype, "method");
    if (methodDescriptor) {
      var realGet = methodDescriptor.get;
      methodDescriptor.get = function () {
        if (isFormMethodDialog(this)) {
          return "dialog";
        }
        return realGet.call(this);
      };
      var realSet = methodDescriptor.set;
      methodDescriptor.set = function (v) {
        if (typeof v === "string" && v.toLowerCase() === "dialog") {
          return this.setAttribute("method", v);
        }
        return realSet.call(this, v);
      };
      Object.defineProperty(HTMLFormElement.prototype, "method", methodDescriptor);
    }
  }
  document.addEventListener("click", function (ev) {
    dialogPolyfill.formSubmitter = null;
    dialogPolyfill.imagemapUseValue = null;
    if (ev.defaultPrevented) {
      return;
    }
    var target = ev.target;
    if ("composedPath" in ev) {
      var path = ev.composedPath();
      target = path.shift() || target;
    }
    if (!target || !isFormMethodDialog(target.form)) {
      return;
    }
    var valid = target.type === "submit" && ["button", "input"].indexOf(target.localName) > -1;
    if (!valid) {
      if (!(target.localName === "input" && target.type === "image")) {
        return;
      }
      dialogPolyfill.imagemapUseValue = ev.offsetX + "," + ev.offsetY;
    }
    var dialog = findNearestDialog(target);
    if (!dialog) {
      return;
    }
    dialogPolyfill.formSubmitter = target;
  }, false);
  document.addEventListener("submit", function (ev) {
    var form = ev.target;
    var dialog = findNearestDialog(form);
    if (dialog) {
      return;
    }
    var submitter = findFormSubmitter(ev);
    var formmethod = submitter && submitter.getAttribute("formmethod") || form.getAttribute("method");
    if (formmethod === "dialog") {
      ev.preventDefault();
    }
  });
  var nativeFormSubmit = HTMLFormElement.prototype.submit;
  var replacementFormSubmit = function () {
    if (!isFormMethodDialog(this)) {
      return nativeFormSubmit.call(this);
    }
    var dialog = findNearestDialog(this);
    dialog && dialog.close();
  };
  HTMLFormElement.prototype.submit = replacementFormSubmit;
}
class LightboxImageController extends BaseController {
  constructor() {
    super(...arguments);
    __publicField(this, "_dialog", null);
  }
  get _src() {
    return this.hasSrcValue ? this.srcValue : this.el.src;
  }
  get _srcSet() {
    return this.hasSrcSetValue ? this.srcSetValue : this.el.srcset;
  }
  get _sizes() {
    return this.hasSizesValue ? this.sizesValue : this.el.sizes;
  }
  get _modalClassName() {
    return this.hasModalClass ? this.modalClass : "image-lightbox-dialog";
  }
  get _imageClassName() {
    return this.hasImageClass ? this.imageClass : "image-lightbox-image";
  }
  initialize() {
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
  }
  connect() {}
  disconnect() {
    this.close();
  }
  open() {
    var _this19 = this;
    let element = this.el;
    if (this._dialog) {
      return;
    }
    this._dialog = document.createElement("dialog");
    let image = document.createElement("img");
    image.className = this._imageClassName;
    image.src = this._src;
    image.srcset = this._srcSet;
    image.sizes = this._sizes;
    this._dialog.appendChild(image);
    element.insertAdjacentElement("afterend", this._dialog);
    dialogPolyfill.registerDialog(this._dialog);
    this._dialog.className = this._modalClassName;
    this._dialog.showModal();
    scrollToElement(this._dialog, {
      behavior: "smooth",
      block: "end"
    }).catch(function () {
      return _this19._dialog.scrollIntoView(false);
    });
    useEventListener(this, this._dialog, "click", this.close);
    useEventListener(this, this._dialog, "cancel", this.close);
    useEventListener(this, this._dialog, "close", this.close);
  }
  close() {
    var _this20 = this;
    if (this._dialog) {
      this._dialog.close();
      this._dialog.remove();
      this._dialog = null;
      scrollToElement(this.el, {
        behavior: "smooth",
        block: "end"
      }).catch(function () {
        return _this20.el.scrollIntoView(false);
      });
    }
  }
}
__publicField(LightboxImageController, "values", {
  src: String,
  srcSet: String,
  sizes: String
});
__publicField(LightboxImageController, "classes", ["modal", "image"]);
class MediaPlayerController extends BaseController {
  async play(event) {
    event == null ? void 0 : event.preventDefault();
    await this.mediaTarget.play();
  }
  pause(event) {
    event == null ? void 0 : event.preventDefault();
    this.mediaTarget.pause();
  }
  restart(event) {
    event == null ? void 0 : event.preventDefault();
    this.mediaTarget.currentTime = 0;
  }
  seek(event) {
    event == null ? void 0 : event.preventDefault();
    this.mediaTarget.currentTime += 5;
  }
}
__publicField(MediaPlayerController, "targets", ["media"]);
class ScrollContainerController extends BaseController {
  get _increment() {
    return this.hasIncrementValue ? this.incrementValue : 50;
  }
  get _behaviour() {
    if (this.hasBehaviourValue) {
      if (["auto", "smooth"].includes(this.behaviourValue)) {
        return this.behaviourValue;
      } else {
        throw new Error("'".concat(this.behaviourValue, "' is not a recognised scroll behaviour"));
      }
    } else {
      return "auto";
    }
  }
  async scrollTop(event) {
    event == null ? void 0 : event.preventDefault();
    await scrollAbsoluteTop(this.el, {
      behavior: this._behaviour
    });
  }
  async scrollBottom(event) {
    event == null ? void 0 : event.preventDefault();
    await scrollAbsoluteBottom(this.el, {
      behavior: this._behaviour
    });
  }
  async scrollLeft(event) {
    event == null ? void 0 : event.preventDefault();
    await scrollAbsoluteLeft(this.el, {
      behavior: this._behaviour
    });
  }
  async scrollRight(event) {
    event == null ? void 0 : event.preventDefault();
    await scrollAbsoluteLeft(this.el, {
      behavior: this._behaviour
    });
  }
  async up(event) {
    event == null ? void 0 : event.preventDefault();
    await scrollUp(this.el, this._increment, {
      behavior: this._behaviour
    });
  }
  async down(event) {
    event == null ? void 0 : event.preventDefault();
    await scrollDown(this.el, this._increment, {
      behavior: this._behaviour
    });
  }
  async left(event) {
    event == null ? void 0 : event.preventDefault();
    await scrollLeft(this.el, this._increment, {
      behavior: this._behaviour
    });
  }
  async right(event) {
    event == null ? void 0 : event.preventDefault();
    await scrollRight(this.el, this._increment, {
      behavior: this._behaviour
    });
  }
}
__publicField(ScrollContainerController, "values", {
  behaviour: String,
  increment: Number
});
class ScrollIntoFocusController extends EphemeralController {
  connect() {
    var _this21 = this;
    requestAnimationFrame(function () {
      scrollToElement(_this21.el, {
        behavior: _this21.hasBehaviorValue ? _this21.behaviorValue : "smooth",
        block: _this21.hasBlockValue ? _this21.blockValue : "center",
        inline: _this21.hasInlineValue ? _this21.inlineValue : "center"
      }).catch(function () {
        return _this21.el.scrollIntoView();
      });
      _this21._cleanupSelf();
    });
  }
}
__publicField(ScrollIntoFocusController, "values", {
  behavior: String,
  block: String,
  inline: String
});
class ScrollToBottomController extends BaseController {
  get _mode() {
    return this.hasModeValue ? this.modeValue : "document";
  }
  get _scrollTarget() {
    let target;
    if (this._mode == "document") {
      target = window;
    } else {
      target = getScrollParent(this.el);
    }
    return target;
  }
  async scroll(event) {
    event == null ? void 0 : event.preventDefault();
    if (this._scrollTarget) {
      await scrollAbsoluteBottom(this._scrollTarget);
    }
  }
}
__publicField(ScrollToBottomController, "values", {
  mode: String
});
class ScrollToController extends BaseController {
  scroll() {
    let target = document.querySelector(this.selectorValue);
    if (!target) {
      console.warn("Could not find target for '".concat(this.selectorValue, "'"));
      return;
    }
    scrollToElement(target, {
      behavior: this.hasBehaviorValue ? this.behaviorValue : "smooth",
      block: this.hasBlockValue ? this.blockValue : "center",
      inline: this.hasInlineValue ? this.inlineValue : "center"
    }).catch(function () {
      return target.scrollIntoView();
    });
  }
}
__publicField(ScrollToController, "values", {
  selector: String,
  behavior: String,
  block: String,
  inline: String
});
class ScrollToTopController extends BaseController {
  get _mode() {
    return this.hasModeValue ? this.modeValue : "document";
  }
  get _scrollTarget() {
    let target;
    if (this._mode == "document") {
      target = window;
    } else {
      target = getScrollParent(this.el);
    }
    return target;
  }
  async scroll(event) {
    event == null ? void 0 : event.preventDefault();
    if (this._scrollTarget) {
      await scrollAbsoluteTop(this._scrollTarget);
    }
  }
}
__publicField(ScrollToTopController, "values", {
  mode: String
});
function extractPredicates(expressionString) {
  expressionString = expressionString.trim();
  let andExpression = expressionString.includes("&&");
  let orExpression = expressionString.includes("||");
  let groupings = expressionString.includes("(") || expressionString.includes(")");
  if (andExpression && orExpression) {
    throw new Error("Cannot have both && and || in the same expression.");
  }
  if (groupings) {
    throw new Error("Cannot have logical groupings `(>3 && <= 9) || (>1 && <2)` in the expression. Only supports simple expressions like  `>1 && <3`");
  }
  let expressions = expressionString.split(andExpression ? "&&" : "||");
  if (andExpression) {
    return expressions.map(function (ex) {
      return _predicateForExpression(ex);
    });
  } else if (orExpression) {
    return expressions.map(function (ex) {
      return _predicateForExpression(ex);
    });
  } else {
    return [_predicateForExpression(expressionString)];
  }
}
function _predicateForExpression(expression) {
  let operators = [">=", "<=", "==", "!=", ">", "<"];
  let operator = operators.find(function (part) {
    return expression.includes(part);
  });
  if (!operator) {
    throw new Error("Could not find operator in expression: ".concat(expression));
  }
  let expressionValue = expression.split(operator)[1].trim();
  let isNumber = /^-?[0-9]\d*(\.\d+)?$/.test(expressionValue);
  expressionValue = isNumber ? parseFloat(expressionValue) : expressionValue;
  if (expressionValue == "") {
    throw new Error("Could not find a value in expression: ".concat(expression));
  }
  let notEmpty = function (signalValue) {
    return signalValue !== "";
  };
  switch (operator) {
    case ">":
      return function (signalValue) {
        return isNumber && notEmpty(signalValue) && signalValue > expressionValue;
      };
    case "<":
      return function (signalValue) {
        return isNumber && notEmpty(signalValue) && signalValue < expressionValue;
      };
    case ">=":
      return function (signalValue) {
        return isNumber && notEmpty(signalValue) && signalValue >= expressionValue;
      };
    case "<=":
      return function (signalValue) {
        return isNumber && notEmpty(signalValue) && signalValue <= expressionValue;
      };
    case "==":
      return function (signalValue) {
        return notEmpty(signalValue) && signalValue == expressionValue;
      };
    case "!=":
      return function (signalValue) {
        return notEmpty(signalValue) && signalValue != expressionValue;
      };
    default:
      throw new Error("Unknown operator ".concat(operator));
  }
}
function signalEventName(name, type) {
  return "signal:".concat(type, ":").concat(name);
}
function signalConnectEvent(name) {
  return signalEventName(name, "connect");
}
function signalValueEvent(name) {
  return signalEventName(name, "value");
}
class SignalActionController extends BaseController {
  get _predicates() {
    return extractPredicates(this.whenValue);
  }
  connect() {
    EventBus.emit(signalConnectEvent(this.nameValue));
    useEventBus(this, signalValueEvent(this.nameValue), this._onSignal);
  }
  _onSignal(payload) {
    let value = payload.value;
    if (!this.hasWhenValue) {
      this.dispatch(this.el, signalEventName(this.nameValue, "match"));
      return;
    }
    if (this._predicates.every(function (predicate) {
      return predicate(value);
    })) {
      this.dispatch(this.el, signalEventName(this.nameValue, "match"), {
        detail: {
          element: this.el,
          value
        }
      });
    } else {
      this.dispatch(this.el, signalEventName(this.nameValue, "no-match"), {
        detail: {
          element: this.el,
          value
        }
      });
    }
  }
}
__publicField(SignalActionController, "values", {
  name: String,
  when: String
});
class SignalInputController extends BaseController {
  get _debounceTimeout() {
    return this.hasDebounceIntervalValue ? this.debounceIntervalValue : null;
  }
  get _name() {
    return this.hasNameValue ? this.nameValue : this.element.name;
  }
  connect() {
    var _this22 = this;
    useEventBus(this, signalConnectEvent(this._name), function () {
      return _this22.emitValue();
    });
    useEventListener(this, this.el, "input", this.emitValue, {
      debounce: this._debounceTimeout || void 0
    });
    useEventListener(this, this.el, "change", this.emitValue);
    requestAnimationFrame(function () {
      return _this22.emitValue();
    });
  }
  emitValue() {
    var _a;
    let value = this.el.value;
    if (isHTMLInputElement(this.el) && this.el.type === "checkbox") {
      value = this.el.checked ? "true" : "false";
    } else if (isHTMLInputElement(this.el) && this.el.type === "radio") {
      let selectedValue = (_a = getAllRadiosInGroup(this.el).find(function (el) {
        return el.checked;
      })) == null ? void 0 : _a.value;
      value = selectedValue ? selectedValue : "";
    }
    EventBus.emit(signalValueEvent(this._name), {
      element: this.el,
      value
    });
  }
}
__publicField(SignalInputController, "values", {
  name: String,
  debounceInterval: Number
});
class SignalVisibilityController extends BaseController {
  get _predicates() {
    return extractPredicates(this.showValue);
  }
  get defaultHideClasses() {
    return ["hide"];
  }
  connect() {
    installClassMethods(this);
    EventBus.emit(signalConnectEvent(this.nameValue));
    useEventBus(this, signalValueEvent(this.nameValue), this._onSignal);
  }
  _onSignal(payload) {
    let value = payload.value;
    if (this.showValue == "default") {
      if (value == "") {
        this.removeHideClasses(this.el);
      } else {
        this.addHideClasses(this.el);
      }
      return;
    }
    if (this._predicates.every(function (predicate) {
      return predicate(value);
    })) {
      this.removeHideClasses(this.el);
    } else {
      this.addHideClasses(this.el);
    }
  }
}
__publicField(SignalVisibilityController, "values", {
  name: String,
  show: String
});
__publicField(SignalVisibilityController, "classes", ["hide"]);
class TableSortController extends BaseController {
  constructor() {
    super(...arguments);
    __publicField(this, "_lastIndex", null);
    __publicField(this, "_reverse", false);
  }
  get _tableHead() {
    let head = this.el.tHead;
    if (head == null) {
      throw new Error("Expected table to have a <thead> element.");
    }
    return head;
  }
  get _tableHeaders() {
    let rows = this._tableHead.rows;
    if (rows.length == 0) {
      throw new Error("Expected table to have a <thead> element with at least one row.");
    }
    return Array.from(rows[0].cells);
  }
  get _tableBody() {
    return this.el.tBodies[0];
  }
  get _tableRows() {
    return Array.from(this._tableBody.rows);
  }
  connect() {
    var _this23 = this;
    requestAnimationFrame(function () {
      useCollectionEventListener(_this23, _this23._tableHeaders, "click", _this23.sort);
      if (_this23.hasStartSortValue) {
        _this23._sortByColumn(_this23.startSortValue);
      }
    });
  }
  sort(event) {
    event.preventDefault();
    let headerCell = event.target;
    let headerCellIndex = this._indexOfHeaderCell(headerCell);
    if (headerCell.dataset.sortable == "false") {
      return;
    }
    if (headerCell.dataset.sort == "asc") {
      this._reverse = true;
      this._otherHeaderCells(headerCell).forEach(function (cell) {
        return delete cell.dataset.sort;
      });
      headerCell.dataset.sort = "desc";
      this._sortByColumn(headerCellIndex);
    } else {
      this._reverse = false;
      this._otherHeaderCells(headerCell).forEach(function (cell) {
        return delete cell.dataset.sort;
      });
      headerCell.dataset.sort = "asc";
      this._sortByColumn(headerCellIndex);
    }
  }
  _indexOfHeaderCell(cell) {
    return this._tableHeaders.indexOf(cell);
  }
  _otherHeaderCells(cell) {
    return Array.from(this._tableHeaders).filter(function (otherCell) {
      return otherCell != cell;
    });
  }
  _sortByColumn(index) {
    var _this24 = this;
    let frag = document.createDocumentFragment();
    let rows = this._tableRows;
    let newRows = rows.sort(function (row, otherRow) {
      var _a, _b;
      let cells = Array.from(row.cells);
      let otherCells = Array.from(otherRow.cells);
      let x = ((_a = cells[index]) == null ? void 0 : _a.innerText) || "";
      let y = ((_b = otherCells[index]) == null ? void 0 : _b.innerText) || "";
      let sortVal = x.localeCompare(y, "en", {
        sensitivity: "base",
        numeric: true,
        caseFirst: "upper"
      });
      if (row.dataset.sortTop || otherRow.dataset.sortBottom) {
        if (row.dataset.sortTop && otherRow.dataset.sortTop) {
          return sortVal;
        }
        return -1;
      }
      if (row.dataset.sortBottom || otherRow.dataset.sortTop) {
        if (row.dataset.sortBottom && otherRow.dataset.sortBottom) {
          return sortVal;
        }
        return 1;
      }
      if (_this24._reverse) {
        return sortVal > 0 ? -1 : 1;
      }
      return sortVal;
    });
    newRows.forEach(function (row) {
      return frag.appendChild(row);
    });
    this._tableBody.innerHTML = "";
    this._tableBody.appendChild(frag);
    this._lastIndex = index;
  }
}
__publicField(TableSortController, "values", {
  startSort: Number
});
function useMutationObserver(controller, element, handler, options) {
  handler = handler.bind(controller);
  let observer = new MutationObserver(handler);
  let setup = function () {
    return observer.observe(element, options);
  };
  let teardown = function () {
    return observer.disconnect();
  };
  useMixin(controller, setup, teardown);
  return teardown;
}
class TableTruncateController extends BaseController {
  get _truncated() {
    return this.hasTruncatedValue ? this.truncatedValue : false;
  }
  set _truncated(value) {
    this.truncatedValue = value;
  }
  get _tableBody() {
    return this.el.tBodies[0];
  }
  get _tableRows() {
    return Array.from(this._tableBody.rows);
  }
  get _limit() {
    return this.hasLimitValue ? this.limitValue : 20;
  }
  connect() {
    var _this25 = this;
    useMutationObserver(this, this._tableBody, this.mutate, {
      childList: true
    });
    requestAnimationFrame(function () {
      _this25.truncate();
      useEventListener(_this25, _this25.showMoreTarget, "click", _this25.expand);
    });
  }
  truncate(event) {
    var _this26 = this;
    event == null ? void 0 : event.preventDefault();
    this._truncated = true;
    if (this._tableRows.length >= this._limit) {
      this._tableRows.slice(this._limit).forEach(function (el) {
        if (el !== _this26.showMoreTarget) {
          _this26._hideElement(el);
        }
      });
      this._showElement(this.showMoreTarget);
    } else {
      this._hideElement(this.showMoreTarget);
    }
  }
  expand(event) {
    var _this27 = this;
    this._truncated = false;
    event == null ? void 0 : event.preventDefault();
    this._tableRows.slice(this._limit).forEach(function (el) {
      if (el !== _this27.showMoreTarget) {
        _this27._showElement(el);
      }
    });
    this._hideElement(this.showMoreTarget);
  }
  mutate(entries) {
    if (this._truncated) {
      this._reTruncate();
    }
  }
  _showElement(el) {
    el.style.display = "";
  }
  _hideElement(el) {
    el.style.display = "none";
  }
  _reTruncate() {
    var _this28 = this;
    this._tableRows.slice(0, this._limit).forEach(function (el) {
      if (el !== _this28.showMoreTarget) {
        _this28._showElement(el);
      }
    });
    this._tableRows.slice(this._limit).forEach(function (el) {
      if (el !== _this28.showMoreTarget) {
        _this28._hideElement(el);
      }
    });
    this._showElement(this.showMoreTarget);
  }
}
__publicField(TableTruncateController, "targets", ["showMore"]);
__publicField(TableTruncateController, "values", {
  limit: Number,
  truncated: Boolean
});
class AlertController extends BaseController {
  alert() {
    alert(this.messageValue);
  }
}
__publicField(AlertController, "values", {
  message: String
});
class FullscreenController extends BaseController {
  connect() {
    let _useFullscreen = useFullscreen(this),
      enter = _useFullscreen.enter,
      exit = _useFullscreen.exit,
      toggle = _useFullscreen.toggle;
    this.enter = enter;
    this.exit = exit;
    this.toggle = toggle;
  }
}
class IntersectionController extends BaseController {
  get _threshold() {
    if (this.hasThresholdValue) {
      return this.thresholdValue.split(",").map(function (val) {
        return Number.parseFloat(val.trim());
      }).filter(function (val) {
        return val >= 0 && val <= 1;
      });
    } else {
      return [0, 1];
    }
  }
  connect() {
    useIntersection(this, this.el, this.appear, this.disappear, {
      threshold: this._threshold
    });
  }
  appear(entry) {
    this.dispatch(this.el, "intersection:appear");
  }
  disappear(entry) {
    this.dispatch(this.el, "intersection:disappear");
  }
}
__publicField(IntersectionController, "values", {
  threshold: String
});
class IntervalController extends BaseController {
  connect() {
    var _this29 = this;
    if (!this.hasSecondsValue) {
      throw new Error("Expected `secondsValue` to be present");
    }
    requestAnimationFrame(function () {
      useInterval(_this29, _this29._interval, _this29.secondsValue * 1e3);
    });
  }
  _interval() {
    this.dispatch(this.el, "interval:action");
  }
}
__publicField(IntervalController, "values", {
  seconds: Number
});
class PresenceController extends BaseController {
  get name() {
    return this.hasNameValue ? this.nameValue : "";
  }
  get _addedEventName() {
    return [this.name, "presence", "added"].filter(function (el) {
      return !!el;
    }).join(":");
  }
  get _removedEventName() {
    return [this.name, "presence", "removed"].filter(function (el) {
      return !!el;
    }).join(":");
  }
  connect() {
    this.dispatch(this.el, this._addedEventName);
  }
  disconnect() {
    this.dispatch(this.el, this._removedEventName);
  }
}
__publicField(PresenceController, "values", {
  name: String
});
class PrintController extends BaseController {
  print(event) {
    event == null ? void 0 : event.preventDefault();
    window.print();
  }
}
class TimeoutController extends BaseController {
  connect() {
    var _this30 = this;
    requestAnimationFrame(function () {
      useTimeout(_this30, _this30._timeout, _this30.secondsValue * 1e3);
    });
  }
  _timeout() {
    this.dispatch(this.el, "timeout");
  }
}
__publicField(TimeoutController, "values", {
  seconds: Number
});
class UserFocusController extends BaseController {
  connect() {
    var _this31 = this;
    useEventListener(this, window, ["focus", "blur"], this._handleVisibility);
    useEventListener(this, document, "visibilitychange", this._handleVisibility);
    requestAnimationFrame(function () {
      _this31._handleVisibility();
    });
  }
  appear() {
    this.dispatch(this.el, "user-focus:active");
  }
  away() {
    this.dispatch(this.el, "user-focus:away");
  }
  _handleVisibility() {
    this._documentIsActive() ? this.appear() : this.away();
  }
  _documentIsActive() {
    return document.visibilityState == "visible" && document.hasFocus();
  }
}
class ClockController extends BaseController {
  get _tickInterval() {
    if (this.hasMillisecondsTarget) {
      return 1;
    } else if (this.hasSecondsTarget) {
      return 1e3;
    } else if (this.hasMinutesTarget) {
      return 15e3;
    } else {
      return 3e5;
    }
  }
  connect() {
    var _this32 = this;
    requestAnimationFrame(function () {
      useInterval(_this32, _this32._tick, _this32._tickInterval);
    });
  }
  _tick() {
    let current = new Date();
    if (this.hasHoursTarget) {
      this.hoursTarget.innerHTML = current.getHours().toString().padStart(2, "0");
    }
    if (this.hasMinutesTarget) {
      this.minutesTarget.innerHTML = current.getMinutes().toString().padStart(2, "0");
    }
    if (this.hasSecondsTarget) {
      this.secondsTarget.innerHTML = current.getSeconds().toString().padStart(2, "0");
    }
    if (this.hasMillisecondsTarget) {
      this.millisecondsTarget.innerHTML = current.getMilliseconds().toString().padStart(3, "0");
    }
  }
}
__publicField(ClockController, "targets", ["hours", "minutes", "seconds", "milliseconds"]);
class CountdownController extends BaseController {
  constructor() {
    super(...arguments);
    __publicField(this, "_interval", null);
  }
  get _removeUnused() {
    return this.hasRemoveUnusedValue ? this.removeUnusedValue : false;
  }
  get _deadlineDate() {
    return new Date(this.deadlineValue);
  }
  connect() {
    this._interval = setInterval(this._tick.bind(this), 1e3);
    this.addCountingDownClasses();
  }
  disconnect() {
    this._clearTick();
    this.removeCountingDownClasses();
    this.removeEndedClasses();
  }
  deadlineValueChanged() {
    if (this._interval == null) {
      this._interval = setInterval(this._tick.bind(this), 1e3);
    }
  }
  _tick() {
    try {
      const now = new Date();
      let distance = {};
      if (isPast(this._deadlineDate)) {
        distance = {
          years: 0,
          months: 0,
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0
        };
        this._clearTick();
        this.removeCountingDownClasses();
        this.addEndedClasses();
        this.dispatch(this.el, "countdown:ended");
      } else {
        distance = intervalToDuration({
          start: this._deadlineDate,
          end: now
        });
      }
      if (this.hasYearsTarget) {
        this._updateTarget(this.yearsTarget, this._years(distance));
      }
      if (this.hasMonthsTarget) {
        this._updateTarget(this.monthsTarget, this._months(distance));
      }
      if (this.hasDaysTarget) {
        this._updateTarget(this.daysTarget, this._days(distance));
      }
      if (this.hasHoursTarget) {
        this._updateTarget(this.hoursTarget, this._hours(distance));
      }
      if (this.hasMinutesTarget) {
        this._updateTarget(this.minutesTarget, this._minutes(distance));
      }
      if (this.hasSecondsTarget) {
        this._updateTarget(this.secondsTarget, this._seconds(distance));
      }
    } catch (e) {
      console.error(e);
      this._clearTick();
    }
  }
  _clearTick() {
    if (this._interval) {
      clearInterval(this._interval);
      this._interval = null;
    }
  }
  _updateTarget(target, value) {
    this._removeTargetIfUnused(target, value);
    target.innerHTML = value.toString();
  }
  _removeTargetIfUnused(target, value) {
    if (this._removeUnused) {
      if (value === 0 && target.dataset.unused) {
        if (Number.parseInt(target.dataset.unused) > Date.now() + 1500) {
          target.remove();
        }
      } else if (value == 0) {
        target.dataset.unused = Date.now().toString();
      } else {
        target.dataset.unused = void 0;
      }
    }
  }
  _years(duration) {
    return duration.years || 0;
  }
  _months(duration) {
    return duration.months || 0;
  }
  _days(duration) {
    return duration.days || 0;
  }
  _hours(duration) {
    return duration.hours || 0;
  }
  _minutes(duration) {
    return duration.minutes || 0;
  }
  _seconds(duration) {
    return duration.seconds || 0;
  }
}
__publicField(CountdownController, "values", {
  deadline: String,
  removeUnused: Boolean
});
__publicField(CountdownController, "targets", ["years", "months", "days", "hours", "minutes", "seconds"]);
__publicField(CountdownController, "classes", ["countingDown", "ended"]);
class DurationController extends BaseController {
  get _format() {
    return ["years", "months", "weeks", "days", "hours", ...(this._minutes ? ["minutes"] : []), ...(this._seconds ? ["seconds"] : [])];
  }
  get _output() {
    let _this$_duration = this._duration,
      years = _this$_duration.years,
      months = _this$_duration.months,
      weeks = _this$_duration.weeks,
      days = _this$_duration.days,
      hours = _this$_duration.hours,
      minutes = _this$_duration.minutes,
      seconds = _this$_duration.seconds;
    years || (years = 0);
    months || (months = 0);
    weeks || (weeks = 0);
    days || (days = 0);
    hours || (hours = 0);
    minutes || (minutes = 0);
    seconds || (seconds = 0);
    let largeDenominators = [years, months, weeks, days, hours];
    if (!this._minutes && !this._seconds && largeDenominators.every(function (x) {
      return x === 0;
    })) {
      minutes = minutes + seconds / 60;
      return "".concat((minutes / 60).toFixed(1), " hours");
    }
    return formatDuration(this._duration, {
      format: this._format,
      delimiter: ", "
    });
  }
  get _seconds() {
    return this.hasSecondsValue ? this.secondsValue : true;
  }
  get _minutes() {
    return this.hasMinutesValue ? this.minutesValue : true;
  }
  get _timestamp() {
    if (this.hasTimestampValue) {
      return toDate(this.timestampValue * 1e3);
    } else {
      throw new Error("Expected `timestampValue` to be present");
    }
  }
  get _duration() {
    return intervalToDuration({
      start: new Date(),
      end: this._timestamp
    });
  }
  get _tickInterval() {
    if (this._seconds) {
      return 1e3;
    } else if (this._minutes) {
      return 15e3;
    } else {
      return 12e4;
    }
  }
  connect() {
    this._clearInterval = useInterval(this, this._update, this._tickInterval);
    this._update();
  }
  _update() {
    try {
      this.el.innerHTML = this._output;
    } catch {
      this._clearInterval();
    }
  }
}
__publicField(DurationController, "values", {
  timestamp: Number,
  minutes: Boolean,
  seconds: Boolean
});
class TabsController extends BaseController {
  get defaultHideClasses() {
    return ["hide"];
  }
  get defaultActiveClasses() {
    return ["is-active"];
  }
  get _currentTab() {
    return this.hasCurrentTabValue ? this.currentTabValue : 0;
  }
  get _equalize() {
    return this.hasEqualizeValue ? this.equalizeValue : false;
  }
  connect() {
    useCollectionEventListener(this, this.linkTargets, "click", this.switchTabs);
    if (this._equalize) {
      this._setMinHeight();
    }
    this.currentTabValue = this._currentTab;
  }
  switchTabs(event) {
    event.preventDefault();
    this.currentTabValue = this.linkTargets.indexOf(event.currentTarget);
  }
  currentTabValueChanged() {
    let index = this._currentTab;
    index = this._clampIndex(index);
    this._selectTab(index);
  }
  _selectTab(index) {
    var _this33 = this;
    index = this._clampIndex(index);
    let links = this.linkTargets;
    let panels = this.contentTargets;
    let activePanel = panels[index];
    let activeLink = links[index];
    let otherPanels = [...panels.slice(0, index), ...panels.slice(index + 1)];
    let otherLinks = [...links.slice(0, index), ...links.slice(index + 1)];
    this.addActiveClasses(activeLink);
    activeLink.setAttribute("aria-selected", "true");
    this.addActiveClasses(activePanel);
    this.removeHideClasses(activePanel);
    otherLinks.forEach(function (link) {
      link.removeAttribute("aria-selected");
      _this33.removeActiveClasses(link);
    });
    otherPanels.forEach(function (panel) {
      _this33.removeActiveClasses(panel);
      _this33.addHideClasses(panel);
    });
  }
  _clampIndex(index) {
    return clamp(index, 0, this.contentTargets.length - 1);
  }
  _setMinHeight() {
    var _this34 = this;
    let minHeight = 0;
    this.contentTargets.forEach(function (content) {
      let hidden = content.hasAttribute("tab-hidden");
      if (hidden) {
        _this34.removeHideClasses(content);
      }
      let height = content.offsetHeight;
      if (height > minHeight) {
        minHeight = height;
      }
      if (hidden) {
        _this34.addHideClasses(content);
      }
    });
    this.contentTargets.forEach(function (content) {
      return content.style.minHeight = minHeight + "px";
    });
  }
}
__publicField(TabsController, "values", {
  currentTab: Number,
  equalize: Boolean
});
__publicField(TabsController, "targets", ["link", "content"]);
__publicField(TabsController, "classes", ["active", "hide"]);
class TimeDistanceController extends BaseController {
  get _duration() {
    return isPast(this._timestamp) ? intervalToDuration({
      start: this._timestamp,
      end: new Date()
    }) : intervalToDuration({
      start: new Date(),
      end: this._timestamp
    });
  }
  get _nextUpdate() {
    let duration = this._duration;
    if (duration.years && duration.years > 0) {
      return null;
    } else if (duration.months && duration.months > 0) {
      return null;
    } else if (duration.days && duration.days > 0) {
      return null;
    } else if (duration.hours && duration.hours > 0) {
      return 18e5;
    } else {
      return 3e4;
    }
  }
  timestampValueChanged() {
    this._timestamp = toDate(this.timestampValue * 1e3);
  }
  connect() {
    if (!this.hasTimestampValue) {
      throw new Error("Expected `timestampValue` to be present");
    }
    this._update();
  }
  _update() {
    this.el.innerHTML = formatDistanceToNow(this._timestamp, {
      addSuffix: true,
      includeSeconds: true
    });
    if (this._nextUpdate) {
      useTimeout(this, this._update, this._nextUpdate);
    }
  }
}
__publicField(TimeDistanceController, "values", {
  timestamp: Number
});
class TreeViewController extends BaseController {
  get defaultActiveClasses() {
    return ["active"];
  }
  get defaultCollapsedClasses() {
    return ["collapsed"];
  }
  initialize() {
    this._nodeClicked = this._nodeClicked.bind(this);
  }
  connect() {
    installClassMethods(this);
    useMutationObserver(this, this.el, this.mutate, {
      subtree: true,
      childList: true
    });
    this._setup();
  }
  disconnect() {
    this._teardown();
  }
  _setup() {
    this._setupNode(this.el);
  }
  _setupNode(el) {
    var _this35 = this;
    const process = function (e) {
      let parent = e.parentElement;
      if (parent) {
        if (!_this35._nodeActive(parent)) {
          _this35._hideNode(parent);
        }
        parent.removeEventListener("click", _this35._nodeClicked);
        parent.addEventListener("click", _this35._nodeClicked);
      }
    };
    if (el.tagName === "UL" || el.tagName === "OL") {
      process(el);
    }
    el.querySelectorAll("ul, ol").forEach(function (e) {
      return process(e);
    });
  }
  _teardown() {
    var _this36 = this;
    this.el.querySelectorAll("ul, ol, li").forEach(function (el) {
      return _this36._teardownNode(el);
    });
  }
  _teardownNode(el) {
    var _this37 = this;
    [el, ...Array.from(el.querySelectorAll("ul, ol, li"))].forEach(function (x) {
      x.removeEventListener("click", _this37._nodeClicked);
      _this37.removeActiveClasses(x);
      _this37.removeCollapsedClasses(x);
    });
  }
  _nodeClicked(event) {
    if (event) {
      event.stopImmediatePropagation();
    }
    let el = event.target;
    if (!el || !this._hasNested(el)) {
      return;
    }
    if (this._nodeActive(el)) {
      this._hideNode(el);
    } else {
      this._showNode(el);
    }
  }
  _nodeActive(el) {
    return this.activeClassesPresent(el);
  }
  _showNode(el) {
    this.removeCollapsedClasses(el);
    this.addActiveClasses(el);
  }
  _hideNode(el) {
    this.removeActiveClasses(el);
    this.addCollapsedClasses(el);
  }
  _hasNested(el) {
    return el.querySelectorAll("ul, ol").length > 0;
  }
  mutate(entries) {
    var _this38 = this;
    console.log("mutate", entries);
    for (const mutation of entries) {
      if (mutation.type === "childList") {
        Array.from(mutation.addedNodes || []).forEach(function (el) {
          return _this38._setupNode(el);
        });
        Array.from(mutation.removedNodes || []).forEach(function (el) {
          return _this38._teardownNode(el);
        });
      }
    }
  }
}
__publicField(TreeViewController, "classes", ["active", "collapsed"]);
class AnchorSpyController extends BaseController {
  get defaultActiveClasses() {
    return ["active"];
  }
  get defaultInactiveClasses() {
    return ["inactive"];
  }
  get _key() {
    return this.keyValue.replaceAll("#", "");
  }
  get _anchor() {
    return window.location.hash.substr(1);
  }
  set _anchor(value) {
    window.location.hash = value;
  }
  connect() {
    var _this39 = this;
    installClassMethods(this);
    requestAnimationFrame(function () {
      _this39._checkAnchor();
      useEventListener(_this39, window, "hashchange", _this39._checkAnchor);
    });
  }
  write(event) {
    event == null ? void 0 : event.preventDefault();
    this._anchor = this._key;
  }
  _checkAnchor() {
    if (this._key === this._anchor) {
      this.dispatch(this.el, "anchor-spy:active");
      this.addActiveClasses(this.el);
      this.removeInactiveClasses(this.el);
    } else {
      this.dispatch(this.el, "anchor-spy:inactive");
      this.addInactiveClasses(this.el);
      this.removeActiveClasses(this.el);
    }
  }
}
__publicField(AnchorSpyController, "values", {
  key: String
});
__publicField(AnchorSpyController, "classes", ["active", "inactive"]);
class BackLinkController extends BaseController {
  get _pages() {
    return this.hasPagesValue ? Math.abs(this.pagesValue) : 1;
  }
  get _timeout() {
    return this.hasTimeoutValue ? this.timeoutValue : 1500;
  }
  connect() {
    useEventListener(this, this.el, "click", this.goBack);
  }
  goBack(event) {
    event == null ? void 0 : event.preventDefault();
    history.go(-this._pages);
    if (this.el.href) {
      useTimeout(this, this.fallback, this._timeout);
    }
  }
  fallback() {
    window.location.href = this.el.href;
  }
}
__publicField(BackLinkController, "values", {
  timeout: Number,
  pages: Number
});
class ClipboardController extends BaseController {
  constructor() {
    super(...arguments);
    __publicField(this, "_supported", false);
  }
  connect() {
    this._supported = document.queryCommandSupported("copy");
    if (this.hasRemoveUnusedValue && this.removeUnusedValue) {
      if (this._supported && this.hasFallbackTarget) {
        this.fallbackTarget.remove();
      } else if (this.hasCopyTarget) {
        this.copyTarget.remove();
      }
    }
  }
  select(event) {
    if (event) {
      event.preventDefault();
    }
    this.sourceTarget.select();
  }
  copy(event) {
    if (event) {
      event.preventDefault();
    }
    this.sourceTarget.select();
    if (this._supported) {
      document.execCommand("copy");
    }
  }
}
__publicField(ClipboardController, "targets", ["source", "button", "copy", "fallback"]);
__publicField(ClipboardController, "values", {
  removeUnused: Boolean
});
class ConfirmController extends BaseController {
  get _message() {
    return this.hasMessageValue ? this.messageValue : "Are you sure?";
  }
  get _eventType() {
    if (isHTMLFormElement(this.el)) {
      return "submit";
    } else if (isHTMLAnchorElement(this.el)) {
      return "click";
    } else {
      throw new Error("Can't handle confirmation on attached element");
    }
  }
  connect() {
    var _this40 = this;
    requestAnimationFrame(function () {
      useEventListener(_this40, _this40.el, _this40._eventType, _this40.confirm);
    });
  }
  confirm(event) {
    if (!window.confirm(this._message)) {
      event.preventDefault();
      this.dispatch(this.el, "confirm:cancelled");
    }
  }
}
__publicField(ConfirmController, "values", {
  message: String
});
class ConfirmNavigationController extends BaseController {
  get _message() {
    return this.hasMessageValue ? this.messageValue : "Do you want to leave this page? Changes you made may not be saved";
  }
  connect() {
    var _this41 = this;
    window.onbeforeunload = function () {
      return _this41._message;
    };
    useEventListener(this, window, "popstate", this.confirmNavigation);
    useEventListener(this, window, "submit", this.allowSubmit);
    useEventListener(this, window, ["turbolinks:before-visit", "turbo:before-visit"], this.confirmTurboNavigation);
  }
  disconnect() {
    window.onbeforeunload = null;
  }
  allowSubmit(_event) {
    window.removeEventListener("popstate", this.confirmNavigation);
    window.onbeforeunload = null;
  }
  confirmNavigation(_event) {
    return false;
  }
  confirmTurboNavigation(event) {
    if (!confirm(this._message)) {
      event.preventDefault();
    }
  }
}
__publicField(ConfirmNavigationController, "values", {
  message: String
});
class DebugController extends BaseController {
  connect() {
    console.log("Debug Controller", this, this.testTargets);
  }
}
__publicField(DebugController, "targets", ["test"]);
class DisableWithController extends BaseController {
  constructor() {
    super(...arguments);
    __publicField(this, "_cacheText");
  }
  get _message() {
    return this.hasMessageValue ? this.messageValue : "Submitting...";
  }
  get _timeout() {
    return this.hasTimeoutValue ? this.timeoutValue : 1e3;
  }
  connect() {
    var _this42 = this;
    requestAnimationFrame(function () {
      useEventListener(_this42, _this42.el, ["click"], _this42.disable);
      useEventListener(_this42, window, ["turbo:load", "turbolinks:load"], _this42._enable);
    });
  }
  disable(event) {
    let element = this.el;
    if (this._isDisabled(element)) {
      event == null ? void 0 : event.preventDefault();
      event == null ? void 0 : event.stopImmediatePropagation();
    } else {
      this._cacheText = this._getElText(element);
      this._setElText(element, this._message);
      this._disable();
      useTimeout(this, this.enable, this._timeout);
    }
  }
  enable(event) {
    event == null ? void 0 : event.preventDefault();
    let element = this.el;
    if (this._isDisabled(element)) {
      this._setElText(element, this._cacheText);
      this._enable();
    }
  }
  _isDisabled(el) {
    if (isHTMLInputElement(el) && el.type == "submit" || isHTMLButtonElement(el)) {
      return el.disabled;
    } else {
      return el.dataset.disabled == "true";
    }
  }
  _getElText(el) {
    if (isHTMLInputElement(el) && el.type == "submit") {
      return el.value;
    } else {
      return el.innerText;
    }
  }
  _setElText(el, str) {
    if (isHTMLInputElement(el) && el.type == "submit") {
      el.value = str;
    } else if (isHTMLButtonElement(el) || isHTMLAnchorElement(el)) {
      el.innerText = str;
    }
  }
  _disable() {
    let el = this.el;
    if (isHTMLInputElement(el) && el.type == "submit" || isHTMLButtonElement(el)) {
      el.disabled = true;
    } else {
      el.dataset.disabled = "true";
    }
  }
  _enable() {
    let el = this.el;
    if (isHTMLInputElement(el) && el.type == "submit" || isHTMLButtonElement(el)) {
      el.disabled = false;
    } else {
      el.dataset.disabled = void 0;
    }
  }
}
__publicField(DisableWithController, "values", {
  message: String,
  timeout: Number
});
class DismissableController extends BaseController {
  dismiss() {
    this.el.remove();
  }
}
class RemoveController extends DismissableController {}
class ElementSaveController extends BaseController {
  get _id() {
    if (this.hasIdValue) {
      return this.idValue;
    }
    let elementID = this.el.id;
    if (elementID !== "") {
      return elementID;
    } else {
      throw new Error("No ID value to uniquely identify this element. Please either specify data-".concat(this.identifier, "-id-value or give this element an 'id' attribute. "));
    }
  }
  get _uniqueIdentifier() {
    const url = location.href;
    return "".concat(url, " ").concat(this._id);
  }
  get _restoreOnLoad() {
    return this.hasRestoreOnLoadValue ? this.restoreOnLoadValue : true;
  }
  get _element() {
    return this.hasElementTarget ? this.elementTarget : this.el;
  }
  connect() {
    var _this43 = this;
    requestAnimationFrame(function () {
      if (_this43._restoreOnLoad) {
        _this43.restore();
      }
    });
  }
  clear(event) {
    if (event) {
      event.preventDefault();
    }
    localStorage.removeItem(this._uniqueIdentifier);
    this.dispatch(this._element, "element-save:cleared");
  }
  save(event) {
    if (event) {
      event.preventDefault();
    }
    let element = this._element;
    let attributes = this.attributesValue.split(" ");
    let data = {};
    attributes.forEach(function (attr) {
      return data[attr] = get(element, attr);
    });
    localStorage.setItem(this._uniqueIdentifier, JSON.stringify(data));
    this.dispatch(element, "element-save:save:success");
  }
  restore(event) {
    if (event) {
      event.preventDefault();
    }
    let element = this._element;
    if (localStorage.getItem(this._uniqueIdentifier)) {
      const savedData = JSON.parse(localStorage.getItem(this._uniqueIdentifier));
      Object.keys(savedData).forEach(function (attr) {
        set(element, attr, savedData[attr]);
      });
      this.dispatch(element, "element-save:restore:success");
    } else {
      this.dispatch(element, "element-save:restore:empty");
    }
  }
}
__publicField(ElementSaveController, "targets", ["element"]);
__publicField(ElementSaveController, "values", {
  id: String,
  attributes: String,
  restoreOnLoad: Boolean
});
class EmptyDomController extends BaseController {
  get _container() {
    return this.hasContainerTarget ? this.containerTarget : this.el;
  }
  get _children() {
    let element = this._container;
    if (this.hasScopeSelectorValue) {
      return Array.from(element.querySelectorAll(this.scopeSelectorValue));
    } else {
      return Array.from(element.children);
    }
  }
  connect() {
    installClassMethods(this);
    useMutationObserver(this, this._container, this.mutate, {
      childList: true
    });
    this.checkEmpty();
  }
  mutate(entries) {
    this.checkEmpty();
  }
  checkEmpty() {
    let element = this._container;
    let children = this._children;
    if (children.length === 0) {
      this.removeNotEmptyClasses();
      this.addEmptyClasses();
      this.dispatch(element, "dom:empty");
    } else {
      this.addNotEmptyClasses();
      this.removeEmptyClasses();
      this.dispatch(element, "dom:not-empty", {
        detail: {
          count: children.length
        }
      });
    }
  }
}
__publicField(EmptyDomController, "targets", ["container"]);
__publicField(EmptyDomController, "classes", ["empty", "notEmpty"]);
__publicField(EmptyDomController, "values", {
  scopeSelector: String
});
class PrefetchController extends BaseController {
  get _mode() {
    return this.hasModeValue ? this.modeValue : "mouseover";
  }
  get _supportsPrefetch() {
    var _a, _b;
    const link = document.createElement("link");
    return ((_a = link.relList) == null ? void 0 : _a.supports) && ((_b = link.relList) == null ? void 0 : _b.supports("prefetch"));
  }
  get _href() {
    return this.el.href;
  }
  get _existingPrefetch() {
    return (document.head.querySelectorAll("link[rel=\"prefetch\"][href=\"".concat(this._href, "\"]")) || []).length > 0;
  }
  get _connectionSuitable() {
    const connection = navigator.connection;
    if (!connection) {
      return true;
    }
    if (connection) {
      if (connection.saveData) {
        this.warn("Data Saving is enabled");
        return false;
      }
      if (/2g/.test(connection.effectiveType)) {
        this.warn("Network is too slow");
        return false;
      }
    }
    return true;
  }
  connect() {
    if (!this._supportsPrefetch) {
      return;
    }
    switch (this._mode) {
      case "intersect":
        this._setupObserver();
        break;
      case "mouseover":
        useEventListener(this, this.el, "mouseover", this.prefetch, {
          once: true
        });
        break;
      default:
        throw new Error("'".concat(this._mode, "' is not a supported prefetch mode"));
    }
  }
  _setupObserver() {
    var _this44 = this;
    const observer = new IntersectionObserver(function (_ref10, observer2) {
      let _ref11 = _slicedToArray(_ref10, 1),
        entry = _ref11[0];
      if (entry.isIntersecting) {
        _this44.prefetch();
        observer2.unobserve(entry.target);
      }
    });
    observer.observe(this.element);
  }
  prefetch() {
    if (this._existingPrefetch || !this._connectionSuitable) {
      return;
    }
    const link = document.createElement("link");
    Object.assign(link, {
      rel: "prefetch",
      href: this._href,
      as: "document"
    });
    document.head.appendChild(link);
  }
}
__publicField(PrefetchController, "values", {
  mode: String
});
class PrintButtonController extends PrintController {
  get defaultUnsupportedClasses() {
    return ["unsupported"];
  }
  connect() {
    installClassMethods(this);
    if (!("print" in window)) {
      this.addUnsupportedClasses();
    }
    useEventListener(this, this.el, "click", this.print);
  }
}
__publicField(PrintButtonController, "classes", ["unsupported"]);
class ResponsiveIframeWrapperController extends BaseController {
  connect() {
    useEventListener(this, window, "message", this.messageReceived);
  }
  messageReceived(message) {
    let data = message.data;
    if (data.hasOwnProperty("name") && data.name === "iframe-body" && data.hasOwnProperty("height")) {
      this.resize(data.height);
    }
  }
  resize(height) {
    this.el.style.height = "".concat(height, "px");
  }
}
class ResponsiveIframeBodyController extends BaseController {
  connect() {
    if (window.self !== window.top) {
      useEventListener(this, window, "resize", this.postUpdate, {
        debounce: 200
      });
      this.postUpdate();
    }
  }
  postUpdate() {
    let payload = {
      name: "iframe-body",
      height: this.getHeight()
    };
    window.parent.postMessage(payload, "*");
  }
  getHeight() {
    const body = document.body;
    const html = document.documentElement;
    return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
  }
}
class SelfDestructController extends BaseController {
  connect() {
    var _this45 = this;
    requestAnimationFrame(function () {
      useTimeout(_this45, function () {
        return _this45.el.remove();
      }, _this45.secondsValue * 1e3);
    });
  }
}
__publicField(SelfDestructController, "values", {
  seconds: Number
});
class StickyController extends BaseController {
  constructor() {
    super(...arguments);
    __publicField(this, "_magicElement", null);
  }
  get defaultStuckClasses() {
    return ["stuck"];
  }
  get _mode() {
    if (this.hasModeValue) {
      if (!["top", "bottom"].includes(this.modeValue)) {
        throw new Error("The modeValue provided '".concat(this.modeValue, "' is not one of the recognised configuration options"));
      }
      if (this.modeValue === "top") {
        return "beforebegin";
      }
    }
    return "afterend";
  }
  connect() {
    var _this46 = this;
    this._magicElement = document.createElement("div");
    useInjectedElement(this, this.el, this._mode, this._magicElement);
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.target !== _this46._magicElement) {
          return;
        }
        if (entry.intersectionRatio === 0) {
          _this46.addStuckClasses();
        } else if (entry.intersectionRatio === 1) {
          _this46.removeStuckClasses();
        }
      });
    }, {
      threshold: [0, 1]
    });
    observer.observe(this._magicElement);
  }
}
__publicField(StickyController, "classes", ["stuck"]);
__publicField(StickyController, "values", {
  mode: String
});
class TeleportController extends EphemeralController {
  connect() {
    var _this47 = this;
    if (!this.hasInsertValue) {
      throw new Error("`insert` value was not specified");
    }
    requestAnimationFrame(function () {
      if (_this47.hasImmediateValue && _this47.immediateValue) {
        _this47.execute();
      }
    });
  }
  execute(event) {
    event == null ? void 0 : event.preventDefault();
    let element = this.el;
    let destination = document.querySelector(this.targetValue);
    if (destination == null) {
      this.dispatch(element, "teleport:error");
      return;
    }
    let copy = element.cloneNode(true);
    this.cleanup(copy);
    switch (this.insertValue) {
      case "beforebegin":
      case "beforeend":
      case "afterend":
      case "afterbegin":
        destination.insertAdjacentHTML(this.insertValue, copy.outerHTML);
        break;
      case "replaceOuter":
        destination.outerHTML = copy.outerHTML;
        break;
      case "replaceInner":
        destination.innerHTML = copy.outerHTML;
        break;
      case "prepend":
        destination.insertAdjacentHTML("afterbegin", copy.outerHTML);
        break;
      case "append":
        destination.insertAdjacentHTML("beforeend", copy.outerHTML);
        break;
      default:
        throw new Error("`insert` value was not specified");
    }
    element.remove();
  }
}
__publicField(TeleportController, "values", {
  target: String,
  insert: String,
  immediate: Boolean
});
class TemporaryStateController extends EphemeralController {
  constructor() {
    super(...arguments);
    __publicField(this, "_previousState", {});
  }
  get _value() {
    if (this.hasValueValue) {
      return this.valueValue;
    }
    throw new Error("Expected `valueValue` to be present");
  }
  get _attribute() {
    if (this.hasAttributeValue) {
      return this.attributeValue;
    }
    throw new Error("Expected `attributeValue` to be present");
  }
  get _seconds() {
    if (this.hasSecondsValue) {
      return this.secondsValue * 1e3;
    }
    throw new Error("Expected `secondsValue` to be present");
  }
  connect() {
    this.setState();
    useTimeout(this, this.removeState, this._seconds);
  }
  disconnect() {
    this.removeState();
  }
  setState() {
    this._previousState[this._attribute] = get(this.el, this._attribute);
    set(this.el, this._attribute, this.valueValue);
  }
  removeState() {
    set(this.el, this._attribute, this._previousState[this._attribute]);
  }
}
__publicField(TemporaryStateController, "values", {
  attribute: String,
  seconds: Number,
  value: String
});
function applyTemporaryState(element, propertyString, value, seconds) {
  let controllerIdentifier = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "temporary-state";
  var _a;
  if (!element.dataset.controller || !((_a = element.dataset.controller) == null ? void 0 : _a.includes(controllerIdentifier))) {
    element.dataset.controller = (element.dataset.controller || " ".concat(controllerIdentifier, " ")).trim().replaceAll("  ", " ");
  }
  element[camelCase("".concat(controllerIdentifier, "-attribute-value"))] = propertyString;
  element[camelCase("".concat(controllerIdentifier, "-seconds-value"))] = seconds.toString();
}
function applyTemporaryClass(element, value, seconds) {
  applyTemporaryState(element, "className", value, seconds);
}
function useClickOutside(controller, element, callback) {
  callback = callback.bind(controller);
  const handler = function (event) {
    if (element.contains(event.target) || !isElementInViewport(element)) {
      return;
    }
    callback(event);
  };
  let _useEventListener2 = useEventListener(controller, window, ["click", "touchend"], handler),
    teardown = _useEventListener2.teardown;
  useMixin(controller, function () {
    return void 0;
  }, teardown);
  return {
    teardown
  };
}
function useHover(controller, element, enter, leave) {
  let teardownEnter = null;
  let teardownLeave = null;
  if (enter) {
    enter = enter.bind(controller);
    let _useEventListener3 = useEventListener(controller, element, "mouseenter", enter),
      _teardownEnter = _useEventListener3.teardown;
    teardownEnter = _teardownEnter;
  }
  if (leave) {
    leave = leave.bind(controller);
    let _useEventListener4 = useEventListener(controller, element, "mouseleave", leave),
      _teardownLeave = _useEventListener4.teardown;
    teardownLeave = _teardownLeave;
  }
  let setup = function () {
    return void 0;
  };
  let teardown = function () {
    if (teardownEnter) {
      teardownEnter();
    }
    if (teardownLeave) {
      teardownLeave();
    }
  };
  useMixin(controller, setup, teardown);
  return {
    teardown
  };
}
class ToggleClassController extends BaseController {
  connect() {
    var _this48 = this;
    if (!this.hasClassValue) {
      throw new Error("data-toggle-class-class-value must not be empty");
    }
    if (this.hasMouseEnterValue || this.hasMouseLeaveValue) {
      useHover(this, this.el, this.mouseEnter, this.mouseLeave);
    }
    if (this.hasClickAwayValue && this.clickAwayValue) {
      useClickOutside(this, this.el, this.clickOutside);
    }
    requestAnimationFrame(function () {
      if (_this48.hasInitialValue) {
        if (_this48.initialValue === "on") {
          _this48.toggleTargets.forEach(function (target) {
            return _this48._elementOn(target);
          });
        } else {
          _this48.toggleTargets.forEach(function (target) {
            return _this48._elementOff(target);
          });
        }
      }
    });
  }
  clickOutside() {
    var _this49 = this;
    this.toggleTargets.forEach(function (target) {
      if (_this49._elementWasToggled(target)) {
        _this49._elementToggleStatus(target);
        _this49._elementToggle(target);
      }
    });
  }
  mouseEnter() {
    if (this.hasMouseEnterValue) {
      switch (this.mouseEnterValue) {
        case "on":
          this.on();
          break;
        case "off":
          this.off();
          break;
        case "toggle":
          this.toggle();
          break;
      }
    }
    return {};
  }
  mouseLeave() {
    if (this.hasMouseLeaveValue) {
      switch (this.mouseLeaveValue) {
        case "on":
          this.on();
          break;
        case "off":
          this.off();
          break;
        case "toggle":
          this.toggle();
          break;
      }
    }
    return {};
  }
  on(event) {
    var _this50 = this;
    this.toggleTargets.forEach(function (target) {
      _this50._elementToggleStatus(target);
      _this50._elementOn(target);
    });
  }
  off(event) {
    var _this51 = this;
    this.toggleTargets.forEach(function (target) {
      _this51._elementToggleStatus(target);
      _this51._elementOff(target);
    });
  }
  toggle(event) {
    var _this52 = this;
    this.toggleTargets.forEach(function (target) {
      _this52._elementToggleStatus(target);
      _this52._elementToggle(target);
    });
  }
  _elementWasToggled(el) {
    return el.dataset.toggled == "true";
  }
  _elementToggleStatus(el) {
    if (this._elementWasToggled(el)) {
      delete el.dataset.toggled;
    } else {
      el.dataset.toggled = "true";
    }
  }
  _elementToggle(el) {
    let classes = this.classValue.split(" ");
    classes.forEach(function (klass) {
      return el.classList.toggle(klass);
    });
  }
  _elementOn(el) {
    let classes = this.classValue.split(" ");
    classes.forEach(function (klass) {
      return el.classList.toggle(klass, true);
    });
  }
  _elementOff(el) {
    let classes = this.classValue.split(" ");
    classes.forEach(function (klass) {
      return el.classList.toggle(klass, false);
    });
  }
}
__publicField(ToggleClassController, "targets", ["toggle"]);
__publicField(ToggleClassController, "values", {
  class: String,
  mouseEnter: String,
  mouseLeave: String,
  clickAway: Boolean,
  initial: String
});
function useTrixModifiers(controller) {
  const controllerDisconnect = controller.disconnect.bind(controller);
  let observing = false;
  let observerCallback = function (entries, observer2) {
    entries.forEach(function (mutation) {
      if (mutation.type === "childList" && Array.from(mutation.addedNodes).some(function (el) {
        return el.tagName === "TRIX-TOOLBAR";
      })) {
        attemptSetup();
        observer2.disconnect();
      }
    });
  };
  let pasteHandler = function (event) {
    return controllerMethod(controller, "pasteEvent").call(controller, event);
  };
  let observer = new MutationObserver(observerCallback);
  let attemptSetup = function () {
    if (controller.element.tagName !== "TRIX-EDITOR") {
      throw new Error("Expected controller to be mounted on an instance of <trix-editor>");
    }
    let editor = controller.element;
    let editorParent = controller.element.parentElement;
    if (editorParent == null) {
      throw new Error("Could not traverse DOM tree from <trix-editor>");
    }
    editor.addEventListener("trix-paste", pasteHandler);
    let toolbar2 = editorParent.querySelector("trix-toolbar");
    if (!observing && !toolbar2) {
      observing = true;
      observer.observe(editorParent, {
        childList: true
      });
      return;
    } else if (!toolbar2) {
      throw new Error("Could not find an instance of <trix-toolbar> that is a sibling of this <trix-editor>");
    } else {
      observer.disconnect();
    }
    controllerMethod(controller, "install").call(controller, {
      toolbar: toolbar2,
      editor
    });
  };
  let teardown = function () {
    if (controller.element.tagName !== "TRIX-EDITOR") {
      throw new Error("Expected controller to be mounted on an instance of <trix-editor>");
    }
    let editor = controller.element;
    let editorParent = controller.element.parentElement;
    if (editorParent == null) {
      throw new Error("Could not traverse DOM tree from <trix-editor>");
    }
    editor.removeEventListener("trix-paste", pasteHandler);
    let toolbar2 = editorParent.querySelector("trix-toolbar");
    if (!toolbar2) {
      throw new Error("Could not find <trix-toolbar> that is a sibling of this <trix-editor> element");
    }
    controllerMethod(controller, "uninstall").call(controller, {
      toolbar: toolbar2,
      editor
    });
  };
  attemptSetup();
  Object.assign(controller, {
    disconnect() {
      observer.disconnect();
      teardown();
      controllerMethod(controller, "uninstall").call({
        toolbar,
        editor: controller.element
      });
      controllerDisconnect();
    }
  });
}
class TrixModifierController extends BaseController {
  get enabledBehaviours() {
    let enabled = function (datasetProp) {
      return datasetProp !== void 0 && datasetProp !== "false";
    };
    let behaviourIfEnabled = function (datasetProp, trixInstallable) {
      return enabled(datasetProp) ? [trixInstallable] : [];
    };
    return [...behaviourIfEnabled(this.el.dataset.noBold, this.bold), ...behaviourIfEnabled(this.el.dataset.noBulletList, this.bulletList), ...behaviourIfEnabled(this.el.dataset.noCode, this.code), ...behaviourIfEnabled(this.el.dataset.noHeading, this.heading), ...behaviourIfEnabled(this.el.dataset.noItalic, this.italic), ...behaviourIfEnabled(this.el.dataset.noStrikethrough, this.strikethrough), ...behaviourIfEnabled(this.el.dataset.noLink, this.link), ...behaviourIfEnabled(this.el.dataset.noIndents, this.indents), ...behaviourIfEnabled(this.el.dataset.noNumberList, this.numberList), ...behaviourIfEnabled(this.el.dataset.noQuote, this.quote), ...behaviourIfEnabled(this.el.dataset.noFileUploads, this.fileUploads)];
  }
  get bold() {
    return this.formattingHandlers(".trix-button--icon-bold", "bold");
  }
  get bulletList() {
    return this.formattingHandlers(".trix-button--icon-bullet-list", "bullet-list");
  }
  get code() {
    return this.formattingHandlers(".trix-button--icon-code", "code");
  }
  get heading() {
    return this.formattingHandlers(".trix-button--icon-heading-1", "heading");
  }
  get italic() {
    return this.formattingHandlers(".trix-button--icon-italic", "italic");
  }
  get strikethrough() {
    return this.formattingHandlers(".trix-button--icon-strike", "strike");
  }
  get link() {
    return this.formattingHandlers(".trix-button--icon-link", "href");
  }
  get indents() {
    return this.simpleHideShowHandlers([".trix-button--icon-decrease-nesting-level, .trix-button--icon-increase-nesting-level", ".trix-button--icon-decrease-nesting-level, .trix-button--icon-increase-nesting-level"].join(", "));
  }
  get numberList() {
    return this.simpleHideShowHandlers(".trix-button--icon-number-list");
  }
  get quote() {
    return this.simpleHideShowHandlers(".trix-button--icon-quote");
  }
  get fileUploads() {
    let selector = ".trix-button-group.trix-button-group--file-tools";
    let preventUploads = function (e) {
      return e == null ? void 0 : e.preventDefault();
    };
    let self = this;
    let element = this.el;
    return {
      install(elements) {
        self.simpleHideShowHandlers(selector).install(elements);
        self.el.addEventListener("trix-file-accept", preventUploads);
      },
      pasteEvent(event) {
        let _event$paste = event.paste,
          dataTransfer = _event$paste.dataTransfer,
          html = _event$paste.html;
        let editor = element.editor;
        if (dataTransfer.files.length > 0 || html.includes("<img")) {
          alert("The content you pasted contains images and/or files. File uploads are not supported.");
          editor.undo();
        }
      },
      uninstall(elements) {
        self.simpleHideShowHandlers(selector).uninstall(elements);
        self.el.removeEventListener("trix-file-accept", preventUploads);
      }
    };
  }
  connect() {
    useTrixModifiers(this);
  }
  install(elements) {
    this.enabledBehaviours.forEach(function (behaviour) {
      return behaviour.install(elements);
    });
  }
  pasteEvent(event) {
    this.enabledBehaviours.forEach(function (behaviour) {
      return behaviour.pasteEvent && behaviour.pasteEvent(event);
    });
  }
  uninstall(elements) {
    this.enabledBehaviours.forEach(function (behaviour) {
      return behaviour.uninstall(elements);
    });
  }
  simpleHideShowHandlers(selector) {
    var _this53 = this;
    return {
      install: function (_ref12) {
        let toolbar2 = _ref12.toolbar;
        return _this53.hideToolbarSelector(toolbar2, selector);
      },
      uninstall: function (_ref13) {
        let toolbar2 = _ref13.toolbar;
        return _this53.showToolbarSelector(toolbar2, selector);
      }
    };
  }
  formattingHandlers(selector, trixAttribute) {
    var _this54 = this;
    let element = this.el;
    let editor = element.editor;
    return {
      install: function (elements) {
        _this54.simpleHideShowHandlers(selector).install(elements);
      },
      pasteEvent(pasteEvent) {
        let range = pasteEvent.paste.range;
        let prevRange = element.editor.getSelectedRange();
        editor.setSelectedRange(range);
        editor.deactivateAttribute(trixAttribute);
        editor.setSelectedRange(prevRange);
      },
      uninstall: function (elements) {
        _this54.simpleHideShowHandlers(selector).uninstall(elements);
      }
    };
  }
  showToolbarSelector(toolbar2, selector) {
    toolbar2.querySelectorAll(selector).forEach(function (el) {
      return el.style.display = "";
    });
  }
  hideToolbarSelector(toolbar2, selector) {
    toolbar2.querySelectorAll(selector).forEach(function (el) {
      return el.style.display = "none";
    });
  }
}
class TurboFrameRCController extends BaseController {
  toggle(event) {
    event == null ? void 0 : event.preventDefault();
    let frame = this._getFrame();
    let frameSrc = frame.src;
    if (frameSrc == null || frameSrc !== this._getSrc()) {
      this._setSrc();
    } else {
      this._clear();
    }
  }
  setSrc(event) {
    event == null ? void 0 : event.preventDefault();
    this._setSrc();
  }
  clear(event) {
    event == null ? void 0 : event.preventDefault();
    this._clear();
  }
  _setSrc() {
    let frame = this._getFrame();
    if (this.hasLoadingMessageValue) {
      frame.innerHTML = this.loadingMessageValue;
    }
    frame.src = this._getSrc();
  }
  _clear() {
    let frame = this._getFrame();
    frame.src = "";
    frame.innerHTML = "";
  }
  _getFrame() {
    let frame = document.getElementById("".concat(this.frameIdValue));
    if (frame == null) {
      throw new Error("Could not find frame with ID '".concat(this.frameIdValue, "'"));
    }
    if (!isTurboFrame(frame)) {
      throw new Error("Element targeted by ID '".concat(this.frameIdValue, "'"));
    } else {
      return frame;
    }
  }
  _getSrc() {
    let element = this.el;
    if (this.hasSrcValue) {
      return this.srcValue;
    } else if (isHTMLAnchorElement(element)) {
      return element.href;
    } else {
      throw new Error("No link given to drive frame to");
    }
  }
}
__publicField(TurboFrameRCController, "values", {
  frameId: String,
  src: String,
  loadingMessage: String
});
class TurboFrameRefreshController extends BaseController {
  get _poll() {
    return this.hasPollValue ? this.pollValue : false;
  }
  connect() {
    var _this55 = this;
    let element = this.el;
    if (isTurboFrame(element)) {
      if (!!element.src) {
        throw new Error("The provided <turbo-frame> element has no `src` attribute.");
      }
    } else {
      throw new Error("Expected controller to be mounted on a <turbo-frame> element.");
    }
    if (this._poll) {
      requestAnimationFrame(function () {
        return useTimeout(_this55, _this55.refresh, _this55.intervalValue);
      });
    }
  }
  refresh(event) {
    event == null ? void 0 : event.preventDefault();
    let element = this.el;
    element.src = element.src;
  }
}
__publicField(TurboFrameRefreshController, "values", {
  interval: Number,
  poll: Boolean
});
export { AlertController, AnchorSpyController, AsyncBlockController, AutoSubmitFormController, AutosizeController, BackLinkController, BaseController, CharCountController, CheckboxDisableInputsController, CheckboxEnableInputsController, CheckboxSelectAllController, CheckboxXORController, ClipboardController, ClockController, ConfirmController, ConfirmNavigationController, CountdownController, DebugController, DetectDirtyController, DetectDirtyFormController, DisableWithController, DismissableController, DurationController, ElementSaveController, EmptyDomController, EnableInputsController, EphemeralController, EventBus, FallbackImageController, FocusStealController, FormRcController, FormSaveController, FullscreenController, IntersectionController, IntervalController, LazyBlockController, LightboxImageController, LimitedSelectionCheckboxesController, LoadBlockController, MediaPlayerController, NavigateFormErrorsController, NestedFormController, PasswordConfirmController, PasswordPeekController, PollBlockController, PrefetchController, PresenceController, PrintButtonController, PrintController, RemoteFormController, RemoveController, ResponsiveIframeBodyController, ResponsiveIframeWrapperController, ScrollContainerController, ScrollIntoFocusController, ScrollToBottomController, ScrollToController, ScrollToTopController, SelfDestructController, SignalActionController, SignalInputController, SignalVisibilityController, StickyController, StorageSerializers, SyncInputsController, TableSortController, TableTruncateController, TabsController, TeleportController, TemporaryStateController, TimeDistanceController, TimeoutController, ToggleClassController, TreeViewController, TrixModifierController, TurboFrameRCController, TurboFrameRefreshController, UserFocusController, ValueWarnController, WordCountController, applyTemporaryClass, applyTemporaryState, createHiddenButton, createHiddenInput, getAllRadiosInGroup, getOtherRadiosInGroup, getScrollParent, insertElement, insertHiddenButton, insertHiddenInput, isDirty, isElementCheckable, isElementInViewport, isFormDirty, isHTMLAnchorElement, isHTMLButtonElement, isHTMLFormElement, isHTMLImageElement, isHTMLInputElement, isHTMLLinkElement, isHTMLSelectElement, isHTMLTextAreaElement, isTurboFrame, isTypeOfFormInputElement, requestReset, requestSubmit, scrollAbsoluteBottom, scrollAbsoluteLeft, scrollAbsoluteRight, scrollAbsoluteTop, scrollDown, scrollLeft, scrollRight, scrollToElement, scrollUp, useCollectionEventListener, useCollectionEventListeners, useEventListener, useEventListeners, useFullscreen, useGeolocation, useInjectedElement, useInjectedFragment, useInjectedHTML, useInterval, useLocalStorage, useTimeout };